// import ee from '../../services/earth-engine';
export const MARC_L7_XAP = [
  [
    0.22731177508831024, 1.8080672025680542, -0.6189197301864624, -0.004883975721895695, -0.06745853275060654,
    -0.22584623098373413, -2.3615312576293945, 0.4400777518749237, -0.07569343596696854, -1.0370208024978638,
    -2.6927967071533203, 0.052835769951343536,
  ],
  [
    -0.05942700058221817, 0.5063765048980713, -0.38231927156448364, -0.5742451548576355, 0.6496801376342773,
    -0.14444619417190552, -0.3487728238105774, 0.2486201375722885, 0.06296977400779724, -0.17439383268356323,
    0.6677078008651733, 0.44103679060935974,
  ],
  [
    -0.0002972288348246366, 0.00208220980130136, 0.284327894449234, -0.42997753620147705, -0.0008608333300799131,
    0.001973232487216592, -0.0007889305124990642, 0.001691517187282443, -0.0003296031500212848, -0.001335108419880271,
    0.0015466941986232996, 0.00032327661756426096,
  ],
  [
    0.9224183559417725, -0.5925529599189758, -0.06502353399991989, 0.4169211685657501, -0.01593158207833767,
    1.2357205152511597, 0.4871681332588196, 0.07997693121433258, -1.9595075845718384, 0.2995487451553345,
    0.2094694972038269, -0.6851274371147156,
  ],
  [
    -0.00537775456905365, -0.05943867936730385, -0.0542079396545887, -0.03424902260303497, 0.045005783438682556,
    -0.045207805931568146, -0.00217470433562994, 0.11948852986097336, -0.0034553445875644684, 0.3106042146682739,
    -0.020482467487454414, -0.024480022490024567,
  ],
  [
    -0.029146917164325714, 0.13209332525730133, 0.4212113916873932, 0.3518149256706238, -0.46329444646835327,
    0.4283687472343445, 0.9557636380195618, 0.23235434293746948, -0.22265131771564484, 0.025024088099598885,
    -0.14270652830600739, 0.5433434247970581,
  ],
  [
    -0.0015429639024659991, 0.1685415655374527, -0.3465321660041809, -0.5972145199775696, 0.057546596974134445,
    0.09499889612197876, -0.028935689479112625, -0.4374636709690094, 0.07497018575668335, -0.9765375256538391,
    0.01945098303258419, 0.11838092654943466,
  ],
  [
    0.011263079009950161, -0.07699216157197952, -0.06846742331981659, -0.07300771772861481, -0.2750713527202606,
    0.275252103805542, 0.2005399465560913, -0.09058970957994461, 0.8719778656959534, 0.1503114551305771,
    0.32655227184295654, 0.13882553577423096,
  ],
  [
    -0.3430956304073334, 0.23038482666015625, 0.06538593769073486, 0.22952847182750702, -0.006104289088398218,
    0.6730586290359497, 0.28075799345970154, 1.6107109785079956, -0.2708900272846222, 0.1956847608089447,
    -0.20613634586334229, -0.11039002239704132,
  ],
  [
    -0.3269188106060028, -0.7854880094528198, -0.4819434881210327, -1.4108638763427734, -0.6390641927719116,
    -0.2706906795501709, -1.416731595993042, -0.33183541893959045, -0.6688635945320129, 0.18251626193523407,
    -0.4697597026824951, -0.2312629073858261,
  ],
  [
    0.3259407877922058, 0.16310983896255493, -0.43178310990333557, 0.07865724712610245, -0.26079028844833374,
    -0.01969820261001587, 0.16559568047523499, 0.32042187452316284, 0.29266464710235596, 0.28155744075775146,
    0.36834704875946045, -0.2492453157901764,
  ],
  [
    -0.36069488525390625, 0.11948253959417343, -0.2518545091152191, -0.0839046835899353, 0.07498932629823685,
    0.3108512759208679, -0.2677595317363739, 0.46654027700424194, -0.18793952465057373, 0.03220624476671219,
    -0.2888401746749878, 0.35759681463241577,
  ],
  [
    0.3793164789676666, -0.14131803810596466, -0.259268194437027, -0.15332655608654022, -0.31307315826416016,
    -0.33146995306015015, -0.35784614086151123, -0.4073978364467621, 0.05475020036101341, 0.07667064666748047,
    0.25023794174194336, -0.03839753940701485,
  ],
  [
    0.7803317308425903, 0.44524598121643066, 0.4073961079120636, 0.4379454255104065, 0.41837698221206665,
    0.5351972579956055, -0.04316076263785362, -0.5660083293914795, -0.13525959849357605, 0.04814743250608444,
    -0.405442476272583, -0.19689513742923737,
  ],
  [
    0.6710687279701233, -0.02301093563437462, 0.8967557549476624, 0.12918227910995483, 0.22900071740150452,
    0.1015678346157074, 0.1580086052417755, -0.041097916662693024, 0.3413238525390625, 1.192412257194519,
    0.013122916221618652, -0.07325143367052078,
  ],
  [
    0.11060691624879837, -0.1185915395617485, 0.042993053793907166, -0.5385342240333557, -0.1235581561923027,
    0.0453529991209507, -0.3326306939125061, -0.03253701701760292, -0.12155267596244812, 0.12554213404655457,
    0.03203761577606201, 0.7363471388816833,
  ],
  [
    0.13587762415409088, -0.909980833530426, -0.19778117537498474, 0.6601999402046204, -0.1162400171160698,
    0.3966747522354126, -0.042810019105672836, 0.7955760359764099, 0.0771050751209259, 0.8207136392593384,
    -0.05556201934814453, -0.011434345506131649,
  ],
  [
    0.17512942850589752, 0.10731887072324753, -0.15113066136837006, 0.22972653806209564, 0.030204398557543755,
    -0.09479152411222458, -0.16891129314899445, -0.0217899139970541, 0.2233133763074875, 0.3673231899738312,
    -0.38809895515441895, 0.6847577691078186,
  ],
  [
    0.16174867749214172, -0.46620410680770874, 0.28845906257629395, -0.6654787659645081, 0.9371338486671448,
    -0.355465292930603, 1.2343751192092896, 0.15120041370391846, 0.5339083075523376, -0.18360356986522675,
    -0.18719804286956787, 0.08515079319477081,
  ],
  [
    -0.15644006431102753, 0.011521314270794392, 0.33410096168518066, -0.0984809547662735, -0.1824503242969513,
    -0.38025152683258057, -0.1001368835568428, 0.5745295882225037, -0.12032174319028854, 0.18411077558994293,
    -0.2590571641921997, -0.2548278868198395,
  ],
  [
    0.09923837333917618, 0.2450689673423767, 0.06385324895381927, 0.31168514490127563, 0.06797297298908234,
    0.07507545500993729, 0.34582069516181946, -0.5276129841804504, 0.11290174722671509, -0.13768374919891357, 0.0,
    0.3842765688896179,
  ],
  [
    -0.028599556535482407, -0.48487600684165955, -0.03101537562906742, 0.4323817491531372, 0.5079829692840576,
    -0.320422887802124, 0.1378496140241623, 0.14657840132713318, 0.027691196650266647, 0.18314817547798157,
    -0.05408938229084015, 0.4030589759349823,
  ],
  [
    0.013351497240364552, -1.012550711631775, 0.019514363259077072, 0.4414442181587219, 0.1624177247285843,
    0.13695251941680908, 0.17739680409431458, -0.07665921747684479, 0.3468652069568634, -0.032791152596473694,
    -0.00735872145742178, 0.4705631732940674,
  ],
  [
    0.19997726380825043, -0.2115013301372528, 0.10615599900484085, 0.4329199492931366, -0.27461671829223633,
    0.08060050755739212, 0.2662321627140045, -0.13991928100585938, -0.37567904591560364, 0.017109129577875137,
    0.28070971369743347, 0.44433414936065674,
  ],
  [
    -0.44143369793891907, -0.46117010712623596, 0.06597761809825897, 0.4806317687034607, -0.07702838629484177,
    -0.3539053201675415, 0.21851180493831635, -0.03548263758420944, -0.29818713665008545, -0.9896429181098938,
    0.04781561717391014, 0.11227263510227203,
  ],
  [
    0.2990220785140991, 0.036884527653455734, 0.004320514854043722, 0.11322087794542313, 0.19374623894691467,
    0.32694730162620544, -0.0021174198482185602, 0.16466106474399567, -0.0999624952673912, -0.21491655707359314,
    0.07849452644586563, 0.2163478285074234,
  ],
  [
    -0.16762040555477142, 0.6108292937278748, 0.013249440118670464, 0.16761261224746704, -0.17689162492752075,
    0.5859383344650269, 0.005773857701569796, 0.15529346466064453, -0.21227043867111206, -0.04800456389784813,
    -0.4419383406639099, -0.9495463371276855,
  ],
  [
    0.6434547305107117, 0.014767379499971867, -0.069956935942173, -0.1174025684595108, 0.12456464022397995,
    0.059116508811712265, -0.1730748862028122, 0.5359944701194763, -0.2907416820526123, -0.5089444518089294,
    1.0275497436523438, 0.10710618644952774,
  ],
  [
    -0.4391801059246063, -2.664856195449829, -0.14988864958286285, 0.0550883486866951, 0.09202641993761063,
    1.5069888830184937, 0.03569720685482025, -0.30534249544143677, 0.4608233869075775, 1.1102311611175537,
    0.15876735746860504, 0.5423391461372375,
  ],
  [
    0.4284106194972992, 0.08273197710514069, 0.44781798124313354, 0.22902150452136993, 0.09755589812994003,
    0.1633705496788025, -1.1054645776748657, -0.16069228947162628, 0.24636805057525635, 0.22977101802825928,
    0.5345126986503601, -0.1606835573911667,
  ],
  [
    -0.11766175180673599, 0.11432076245546341, -0.006640305742621422, -0.06766144931316376, -0.27358153462409973,
    -0.08536547422409058, 0.019250622019171715, -0.32942137122154236, -0.3292265832424164, 0.337234765291214,
    0.033534493297338486, 0.4247192442417145,
  ],
  [
    0.25929903984069824, 0.2438269853591919, -0.20798063278198242, 0.14560842514038086, -0.465193510055542,
    0.1811051368713379, 0.39934051036834717, 0.16868555545806885, 0.11367392539978027, 0.25617754459381104,
    -0.20164477825164795, 0.3187011480331421,
  ],
  [
    0.011053666472434998, 0.041058529168367386, 0.7950531244277954, 0.03077741526067257, -0.0011814073659479618,
    0.05008021369576454, -0.3239099085330963, 0.01712779328227043, -0.4297688901424408, -0.024097591638565063,
    0.3992738723754883, -0.18231818079948425,
  ],
  [
    0.195547416806221, -0.11267798393964767, -0.12159191071987152, 0.060713618993759155, 0.08047303557395935,
    -0.3243527114391327, 0.039253074675798416, 0.034551192075014114, -0.06378606706857681, -0.154659703373909,
    -0.43782785534858704, -0.7998874187469482,
  ],
  [
    0.013323386199772358, 0.06426999717950821, 0.039459679275751114, 0.26475438475608826, -0.04022559896111488,
    0.10230762511491776, 0.02408243529498577, 0.06563113629817963, 0.12818540632724762, -0.13547472655773163,
    0.01609211601316929, 0.2198425531387329,
  ],
  [
    -0.030403990298509598, 0.06757451593875885, 0.03668352589011192, 0.27329105138778687, 0.08668556809425354,
    0.06889229267835617, 0.02255305089056492, 0.10394363105297089, 0.41645708680152893, -0.186804860830307,
    0.022505298256874084, 0.14143489301204681,
  ],
  [
    -0.12619240581989288, 0.05863514915108681, 0.1651429533958435, 0.2584661841392517, 0.2927476763725281,
    0.04393426701426506, -0.04063934087753296, 0.21529456973075867, 0.38861724734306335, -0.2568245232105255,
    0.01710648648440838, 0.0025859952438622713,
  ],
  [
    0.08586176484823227, 0.0696914866566658, 0.08270492404699326, 0.20198793709278107, 0.22783896327018738,
    -0.050776198506355286, -0.07633703947067261, 0.0944678783416748, 0.05006985366344452, -0.14136359095573425,
    0.11619341373443604, 0.015679186210036278,
  ],
  [
    0.11957034468650818, 0.04294193536043167, 0.1674032062292099, 0.19509565830230713, 0.13298645615577698,
    -0.03082326054573059, -0.2097349613904953, -0.004264228977262974, -0.46480685472488403, -0.04842229187488556,
    0.15155421197414398, -0.0009300687815994024,
  ],
  [
    -0.24034665524959564, 0.06400957703590393, 0.0009311670437455177, 0.3074759840965271, 0.09576573222875595,
    0.22171103954315186, -0.04207112267613411, 0.34033042192459106, -0.06567125767469406, -0.2759833335876465,
    0.013012818992137909, 0.06093760207295418,
  ],
  [
    0.05372525751590729, 0.05372525751590729, 0.05372525751590729, 0.05372525751590729, 0.05372525751590729,
    0.05372525751590729, 0.05372525751590729, 0.05372525751590729, 0.05372525751590729, 0.05372525751590729,
    0.05372525751590729, 0.05372525751590729,
  ],
  [
    0.07643305510282516, 0.07643305510282516, 0.07643305510282516, 0.07643305510282516, 0.07643305510282516,
    0.07643305510282516, 0.07643305510282516, 0.07643305510282516, 0.07643305510282516, 0.07643305510282516,
    0.07643305510282516, 0.07643305510282516,
  ],
  [
    0.11521516740322113, 0.11521516740322113, 0.11521516740322113, 0.11521516740322113, 0.11521516740322113,
    0.11521516740322113, 0.11521516740322113, 0.11521516740322113, 0.11521516740322113, 0.11521516740322113,
    0.11521516740322113, 0.11521516740322113,
  ],
  [
    0.07298101484775543, 0.07298101484775543, 0.07298101484775543, 0.07298101484775543, 0.07298101484775543,
    0.07298101484775543, 0.07298101484775543, 0.07298101484775543, 0.07298101484775543, 0.07298101484775543,
    0.07298101484775543, 0.07298101484775543,
  ],
  [
    0.037197813391685486, 0.037197813391685486, 0.037197813391685486, 0.037197813391685486, 0.037197813391685486,
    0.037197813391685486, 0.037197813391685486, 0.037197813391685486, 0.037197813391685486, 0.037197813391685486,
    0.037197813391685486, 0.037197813391685486,
  ],
  [
    0.11450904607772827, 0.11450904607772827, 0.11450904607772827, 0.11450904607772827, 0.11450904607772827,
    0.11450904607772827, 0.11450904607772827, 0.11450904607772827, 0.11450904607772827, 0.11450904607772827,
    0.11450904607772827, 0.11450904607772827,
  ],
];

export const MARC_L7_XBP = [
  [
    -0.32242870330810547, -1.3038101196289062, -0.07515009492635727, 0.8680274486541748, 0.6782099008560181,
    1.5787575244903564, 0.8199737668037415, -0.08588280528783798, -1.9495227336883545, -1.6952991485595703,
    -0.2523123621940613, -0.19983889162540436,
  ],
  [
    -0.06452476978302002, -0.4102410078048706, -0.32252237200737, 0.842937171459198, 0.4808278977870941,
    0.34411779046058655, 0.6107069849967957, -0.6095685362815857, -0.22095537185668945, -0.9311935305595398,
    -1.0207058191299438, 1.2383604049682617,
  ],
  [
    0.2045135647058487, -0.09666889905929565, 0.3792368173599243, 0.03353855013847351, 0.07026921957731247,
    0.2031988948583603, -0.1841563582420349, -0.2898765504360199, 0.25439444184303284, -0.31579145789146423,
    -0.34550631046295166, -0.38168033957481384,
  ],
  [
    0.09468036890029907, 0.34447112679481506, -0.5346657633781433, -0.8340248465538025, 0.309420645236969,
    0.2560127079486847, -0.6946238279342651, 0.08706045895814896, 0.7160782814025879, 0.22638677060604095,
    0.15777942538261414, -0.12338992953300476,
  ],
  [
    -0.600169837474823, -0.0003951756516471505, 0.0460483655333519, -0.009432695806026459, -0.005438333842903376,
    -0.0011847520945593715, 0.024700650945305824, -0.007725934498012066, -0.007606531027704477, 0.00843809824436903,
    -0.00034286733716726303, 0.005504906643182039,
  ],
  [
    -0.5055345892906189, -0.2986227571964264, -0.41843438148498535, -0.04676361754536629, 0.02971339225769043,
    0.12836922705173492, 0.19077906012535095, -0.002129432512447238, 0.05182764306664467, 0.012336540967226028,
    0.000489373633172363, -0.011922859586775303,
  ],
  [
    -0.5768767595291138, -0.30443450808525085, -0.2730827331542969, 0.12173658609390259, -0.10308965295553207,
    0.06759948283433914, 0.011735743843019009, 0.08252404630184174, 0.011773427948355675, -0.03728516772389412,
    0.016664577648043633, 0.03351035341620445,
  ],
  [
    -0.11406203359365463, 0.17837530374526978, -0.07065897434949875, 0.010700362734496593, -0.45505958795547485,
    -0.5700812339782715, 0.13516084849834442, 0.6399163603782654, 0.3527914881706238, 0.9925689697265625,
    0.9085336923599243, -0.65853351354599,
  ],
  [
    -0.04805506393313408, -0.35196924209594727, -0.17114587128162384, 0.13859808444976807, 0.381109356880188,
    0.4462491273880005, 0.39254650473594666, -0.46173131465911865, -0.2306501418352127, 0.246586412191391,
    0.224652960896492, -0.3964303433895111,
  ],
  [
    0.05008883401751518, 0.062372706830501556, 0.0273948535323143, -0.3553144931793213, -0.20529747009277344,
    -0.49616825580596924, 0.4422653019428253, 0.29958227276802063, 0.04260672628879547, 0.09768705815076828,
    0.5175061225891113, 0.13139371573925018,
  ],
  [
    -0.32604557275772095, 0.4632912874221802, -0.14857442677021027, 0.2490202635526657, 0.18085944652557373,
    0.010483503341674805, -0.2933382987976074, 0.10235869884490967, -0.09930601716041565, -0.16455848515033722,
    0.19445741176605225, 0.1331249475479126,
  ],
  [
    1.0657157897949219, -0.5184439420700073, -0.2093258500099182, -0.2204376608133316, 0.3337515592575073,
    0.15153644979000092, 0.25409719347953796, -0.14630740880966187, -0.39919644594192505, -0.08736616373062134,
    -1.7128163576126099, 0.15252642333507538,
  ],
  [
    -0.15874497592449188, -0.09953249990940094, -0.01114501990377903, 0.6530291438102722, -0.23216164112091064,
    0.08913609385490417, 0.027876228094100952, -0.3569197356700897, -0.2750563323497772, 0.1446439027786255,
    0.2288433164358139, 0.06969509273767471,
  ],
  [
    -0.2339402586221695, 0.07393784821033478, -0.31233060359954834, 0.27117475867271423, -0.48649656772613525,
    0.011866924352943897, -0.04189440235495567, -0.1942451000213623, -0.4599083960056305, -0.46838197112083435,
    -0.027676809579133987, 0.004991244524717331,
  ],
  [
    0.44363075494766235, 0.202585369348526, 0.17422270774841309, -0.305083692073822, -0.4259820282459259,
    -0.3798387348651886, -0.20048122107982635, 0.08255475014448166, 0.01810644380748272, -0.0528748482465744,
    -0.4110957384109497, -0.09313488006591797,
  ],
  [
    -0.32657620310783386, -0.12932097911834717, 0.3255080282688141, -0.1715652197599411, -0.37741756439208984,
    -0.16239207983016968, -0.1645563542842865, 0.08627492934465408, 0.21617870032787323, -0.16336826980113983,
    0.46273255348205566, -0.4795544147491455,
  ],
  [
    -0.0011140663409605622, -0.23040194809436798, -0.23860011994838715, -0.07240647077560425, 0.18347668647766113,
    -0.4728413224220276, -0.48014548420906067, -0.19871659576892853, 0.7717717885971069, 0.1808387190103531,
    0.022032227367162704, -0.029134497046470642,
  ],
  [
    0.41312071681022644, -0.468180775642395, -0.4211796522140503, -0.6804434061050415, 0.0971829891204834,
    -0.23687386512756348, -0.2531225383281708, -0.3245962858200073, 1.8136541843414307, -0.2762368619441986,
    -0.2932174503803253, -0.36986207962036133,
  ],
  [
    -0.0920945405960083, 0.2919108271598816, 1.797363519668579, 1.1182851791381836, 0.04655635356903076,
    -0.41446277499198914, 0.10854914784431458, 0.055179037153720856, 1.0416852235794067, 0.29595497250556946,
    0.2040289342403412, -0.5940436124801636,
  ],
  [
    -0.19491823017597198, -0.5230327248573303, -0.4193840026855469, 0.3425998389720917, -0.32389938831329346,
    -0.3514794111251831, -0.6652921438217163, -1.1409032344818115, 0.37081801891326904, -0.11747276782989502,
    -0.10996869206428528, -0.22875873744487762,
  ],
  [
    0.09085217118263245, -0.08052268624305725, 0.40941768884658813, 0.1488085389137268, -0.06256763637065887,
    -0.12111813575029373, -0.21676339209079742, 0.6389790177345276, 0.16610495746135712, -0.11121402680873871,
    0.7279200553894043, -0.24855166673660278,
  ],
  [
    -0.484476238489151, -0.24656881392002106, -0.04048348218202591, 0.041283026337623596, -0.33279886841773987,
    -0.546987771987915, -0.5321258306503296, 0.18550178408622742, -0.027730604633688927, -0.25438061356544495,
    -0.38423991203308105, -0.2858094573020935,
  ],
  [
    -0.3611353933811188, -0.05960887297987938, 0.2677927613258362, -0.2295953929424286, 0.09958899021148682,
    0.2651645243167877, -0.34019118547439575, -0.2303818166255951, 0.05998824164271355, -0.32305189967155457,
    0.4334293305873871, -0.09762860834598541,
  ],
  [
    0.31957805156707764, 0.1714860498905182, -0.28913357853889465, 0.07668258249759674, -0.6738212704658508,
    -0.15740089118480682, 1.0085679292678833, 0.23622791469097137, -0.47300392389297485, -0.06403014808893204,
    0.2581830322742462, 0.3898283839225769,
  ],
  [
    -0.0866500586271286, -0.3003367781639099, 0.04945158585906029, -0.04978519305586815, -0.5130590200424194,
    0.17316952347755432, -0.5911247134208679, -0.29582473635673523, 0.18921013176441193, -0.0489964559674263,
    -0.1727481335401535, -0.0953999012708664,
  ],
  [
    -0.2516680955886841, 0.2930373549461365, -0.406821608543396, 0.4591730237007141, 0.08518187701702118,
    -0.03162956237792969, 0.27440565824508667, 0.16409406065940857, 0.1264486312866211, 0.30965301394462585,
    0.03883260488510132, -0.28273969888687134,
  ],
  [
    0.3416728973388672, 0.2117968499660492, -0.4846550226211548, 0.4082031548023224, -0.19843286275863647,
    0.034852284938097, 0.09081128984689713, 0.16046875715255737, -0.40941187739372253, -0.23971152305603027,
    0.07440594583749771, 0.3511885106563568,
  ],
  [
    -0.31346914172172546, 0.25320371985435486, 0.15034674108028412, -0.012440893799066544, 0.17590487003326416,
    0.2039356380701065, 0.03686483949422836, 0.23362253606319427, -0.47844037413597107, 0.18169857561588287,
    0.2204730361700058, -0.05870829522609711,
  ],
  [
    -0.025579016655683517, -0.22186064720153809, -0.2152416706085205, 0.018342485651373863, 0.05996772274374962,
    0.2064303159713745, -0.47370579838752747, -0.10093171149492264, -0.15274667739868164, -0.06868154555559158,
    -0.1699991226196289, -0.12046128511428833,
  ],
  [
    -0.016059335321187973, 0.9571858048439026, -0.15783469378948212, 0.664198637008667, -0.9556128978729248,
    -0.14364944398403168, -0.1377401053905487, -0.0905608981847763, 0.21900402009487152, -0.14926232397556305,
    -0.5462286472320557, 0.10382113605737686,
  ],
  [
    -0.1412259042263031, -0.36432772874832153, 0.22702933847904205, 0.36815163493156433, 0.19680777192115784,
    0.4392377734184265, 0.39656510949134827, 0.2145928293466568, 0.008917169645428658, -0.2714557647705078,
    0.14477664232254028, 0.2238607555627823,
  ],
  [
    0.23442158102989197, -0.04407447203993797, 0.21410703659057617, 0.0673285722732544, 0.08112487941980362,
    -0.062359124422073364, -0.022988148033618927, 0.04990912973880768, -0.3245561420917511, -0.7389269471168518,
    -0.0952223688364029, 0.8561804890632629,
  ],
  [
    0.15491783618927002, -0.22304950654506683, 0.34980472922325134, -0.4745957851409912, 0.23717768490314484,
    0.4367658197879791, -0.3222185969352722, -0.0338558703660965, 0.4389263093471527, -0.3966347873210907,
    -0.3589359521865845, 0.14208921790122986,
  ],
  [
    0.3479207754135132, 0.3091631531715393, -0.07716569304466248, -0.021413059905171394, 0.5576921105384827,
    -0.09263080358505249, 0.4429683983325958, 0.15756312012672424, -0.23921124637126923, 0.40556007623672485,
    0.5199145674705505, 0.29121482372283936,
  ],
  [
    0.27230456471443176, 0.15347516536712646, -0.1835780292749405, 0.10884205251932144, 0.08301730453968048,
    -0.31049835681915283, 0.1712653487920761, -0.15882150828838348, 0.029581505805253983, 0.2557516098022461,
    0.22564564645290375, 0.31131672859191895,
  ],
  [
    0.1824025958776474, 0.3353487253189087, 0.15722250938415527, -0.13259777426719666, 0.12160640209913254,
    0.4562082290649414, 0.30529025197029114, -0.11034215986728668, -0.36785805225372314, 0.2264319211244583,
    0.21839678287506104, 0.2809966504573822,
  ],
  [
    0.07461951673030853, 0.5302543640136719, 0.05710439383983612, -0.346027135848999, 0.16916313767433167,
    -0.15178124606609344, 0.43522486090660095, -0.055453263223171234, 0.06554025411605835, 0.15850470960140228,
    0.19664046168327332, 0.21283869445323944,
  ],
  [
    -0.04980941861867905, 0.6155474781990051, 0.574484646320343, -0.19680581986904144, 0.250704288482666,
    -0.333280473947525, 0.44404593110084534, -0.06658913940191269, -0.029967859387397766, 0.019699322059750557,
    0.08021539449691772, 0.039740849286317825,
  ],
  [
    -0.06825674325227737, 0.4939156770706177, -0.4167460501194, -0.016037262976169586, 0.25120002031326294,
    0.10961829870939255, 0.3032580018043518, -0.06127902865409851, -0.3219973146915436, 0.041280657052993774,
    0.009319390170276165, 0.05312831327319145,
  ],
  [
    0.3344472050666809, -0.01012391410768032, -0.49477970600128174, 0.3144189417362213, 0.04128323495388031,
    0.10995197296142578, 0.07225019484758377, -0.1991492211818695, -0.41561320424079895, 0.2818988263607025,
    0.23024049401283264, 0.34641197323799133,
  ],
  [
    0.07211712747812271, 0.07211712747812271, 0.07211712747812271, 0.07211712747812271, 0.07211712747812271,
    0.07211712747812271, 0.07211712747812271, 0.07211712747812271, 0.07211712747812271, 0.07211712747812271,
    0.07211712747812271, 0.07211712747812271,
  ],
  [
    0.060110628604888916, 0.060110628604888916, 0.060110628604888916, 0.060110628604888916, 0.060110628604888916,
    0.060110628604888916, 0.060110628604888916, 0.060110628604888916, 0.060110628604888916, 0.060110628604888916,
    0.060110628604888916, 0.060110628604888916,
  ],
  [
    0.04457755759358406, 0.04457755759358406, 0.04457755759358406, 0.04457755759358406, 0.04457755759358406,
    0.04457755759358406, 0.04457755759358406, 0.04457755759358406, 0.04457755759358406, 0.04457755759358406,
    0.04457755759358406, 0.04457755759358406,
  ],
  [
    0.040994830429553986, 0.040994830429553986, 0.040994830429553986, 0.040994830429553986, 0.040994830429553986,
    0.040994830429553986, 0.040994830429553986, 0.040994830429553986, 0.040994830429553986, 0.040994830429553986,
    0.040994830429553986, 0.040994830429553986,
  ],
  [
    0.02952585183084011, 0.02952585183084011, 0.02952585183084011, 0.02952585183084011, 0.02952585183084011,
    0.02952585183084011, 0.02952585183084011, 0.02952585183084011, 0.02952585183084011, 0.02952585183084011,
    0.02952585183084011, 0.02952585183084011,
  ],
  [
    0.08251411467790604, 0.08251411467790604, 0.08251411467790604, 0.08251411467790604, 0.08251411467790604,
    0.08251411467790604, 0.08251411467790604, 0.08251411467790604, 0.08251411467790604, 0.08251411467790604,
    0.08251411467790604, 0.08251411467790604,
  ],
];

export const MARC_L7_XCP = [
  [
    0.0014784910017624497, -0.0041514490731060505, -0.2553727626800537, 0.00014743237989023328, 0.0007703704759478569,
    -0.05426698923110962, 0.002655847929418087, -0.0002738418697845191, -0.08714360743761063, -0.0018182970816269517,
    0.0018266900442540646, 0.0010155633790418506,
  ],
  [
    0.23293271660804749, -0.036914266645908356, -0.33013463020324707, -0.022131722420454025, -0.18587923049926758,
    -0.5583786368370056, 0.4028628170490265, 0.2259351909160614, -0.18079562485218048, -0.2542681097984314,
    0.33707258105278015, 0.07928050309419632,
  ],
  [
    0.0006422547739930451, -0.0025030544493347406, -0.11499688029289246, -0.000929925125092268, -0.0017216185806319118,
    0.057285308837890625, 0.0008653427939862013, 0.0013485068920999765, -0.41725194454193115, -9.007290645968169e-5,
    0.0012765043647959828, 0.00019065267406404018,
  ],
  [
    4.630094051361084, 0.3498477339744568, -0.4874209761619568, 1.0541999340057373, 0.7826613783836365,
    -0.19408535957336426, 1.5785306692123413, 1.1927385330200195, -0.33558332920074463, 2.2789578437805176,
    -2.6034648418426514, 1.1548384428024292,
  ],
  [
    0.0025253226049244404, 0.0030265036039054394, -0.2555955648422241, 0.0017818489577621222, -0.001177417580038309,
    0.3324957489967346, 0.003690344514325261, 0.002283361740410328, -0.09236160665750504, -0.0017729816026985645,
    0.0024629319086670876, 0.0009915451519191265,
  ],
  [
    0.007623625919222832, 0.005162924062460661, -0.21327340602874756, -0.000999743351712823, 0.004588935524225235,
    0.1702231764793396, 0.01186901330947876, 0.0021255125757306814, -0.21897199749946594, -0.01280216220766306,
    0.012021390721201897, 0.002059129299595952,
  ],
  [
    0.29039615392684937, -1.4989129304885864, -0.3748910427093506, 0.7671756744384766, -0.3549817204475403,
    -0.23381811380386353, 0.11220086365938187, -0.7591211795806885, 0.3202960193157196, 0.2535424828529358,
    0.08773382008075714, -0.0386362187564373,
  ],
  [
    -0.03196762502193451, 0.3354170024394989, 0.0, -0.3929360806941986, 0.46286121010780334, 0.0, -0.13788890838623047,
    0.423597127199173, -0.038171909749507904, 0.3483545780181885, 0.7397115230560303, -0.6759027242660522,
  ],
  [
    -0.4417443871498108, 0.7253736853599548, 0.2917032241821289, 0.29157495498657227, 0.01975320465862751,
    0.0714629590511322, -0.3402794599533081, -0.3536874055862427, -0.33934304118156433, 0.13322506844997406,
    0.12809264659881592, -1.9700686931610107,
  ],
  [
    -0.0900014266371727, 0.11639875173568726, 0.15963615477085114, -0.010198750533163548, 0.31787100434303284,
    -0.06302588433027267, -0.009954843670129776, -0.07404196262359619, -0.323574423789978, 0.06845863163471222,
    0.23121404647827148, 0.2778990566730499,
  ],
  [
    0.010541200637817383, 0.3496110439300537, -0.4470653533935547, -0.21510756015777588, -0.41878390312194824,
    0.11335110664367676, -0.3695864677429199, 0.125726580619812, -0.06407856941223145, 0.03476846218109131,
    0.3546799421310425, 0.4280441999435425,
  ],
  [
    -0.15327595174312592, -0.029217440634965897, -0.008880197070538998, 0.24298352003097534, -0.46697455644607544,
    -0.18062724173069, 0.4091010093688965, -0.4239410161972046, 0.058134760707616806, -0.2122243493795395,
    -0.314913272857666, 0.07485820353031158,
  ],
  [
    0.10036524385213852, 0.35830700397491455, -0.15693747997283936, 0.10405608266592026, -0.21822643280029297,
    0.07826414704322815, 0.3846416771411896, 0.3850175142288208, -0.13605239987373352, -0.07231276482343674,
    0.02096259593963623, 0.308006227016449,
  ],
  [
    -0.1222081184387207, 0.08377468585968018, 0.058144211769104004, -0.35844922065734863, -0.06752395629882812,
    0.062055110931396484, -0.026265978813171387, -0.2995187044143677, 0.1780388355255127, 0.06452298164367676,
    -0.06480860710144043, 0.38261306285858154,
  ],
  [
    0.14658334851264954, 0.07290622591972351, -0.09672174602746964, -0.5657162070274353, -0.3832981288433075,
    0.09036903083324432, -0.03621675446629524, -0.10501325130462646, 0.15674874186515808, -0.5610240697860718,
    -0.3250652551651001, 0.08668582886457443,
  ],
  [
    -0.19597695767879486, 0.4087274372577667, 0.16388656198978424, 0.1847362369298935, -0.5219232439994812,
    0.12189130485057831, 0.8604335784912109, -0.22526931762695312, -0.13556557893753052, -0.0809604749083519,
    0.0925910472869873, 0.3546846807003021,
  ],
  [
    -0.3725694417953491, 0.018418017774820328, 0.45383477210998535, -0.4008413553237915, -0.09850263595581055,
    -0.43462684750556946, 0.07537700235843658, -0.14334797859191895, 0.17360782623291016, 0.012667298316955566,
    0.038721561431884766, 0.16124415397644043,
  ],
  [
    0.4120171070098877, 0.6174762845039368, -0.15349441766738892, -0.2787947654724121, 0.21514379978179932,
    0.1537395566701889, -0.09094836562871933, -0.1252124309539795, -0.310930460691452, 0.2289329618215561,
    -0.22033953666687012, -0.24599064886569977,
  ],
  [
    0.41210153698921204, -0.2950071394443512, -0.42024651169776917, -0.4959159791469574, 0.058677561581134796,
    -0.4453313946723938, -0.06612949073314667, -0.4807206392288208, -0.3529169261455536, -0.25500380992889404,
    -0.2704523801803589, 0.8160644173622131,
  ],
  [
    0.02921408787369728, -0.7283469438552856, -0.8745638132095337, 0.8773393034934998, -0.22981369495391846,
    -0.5876275897026062, -0.20435187220573425, -0.07081878185272217, -0.1619236320257187, -0.47402524948120117,
    0.04005563259124756, -0.05877958610653877,
  ],
  [
    0.33252882957458496, 0.18397921323776245, 0.18623580038547516, -0.524083137512207, -0.08338557928800583,
    0.6486824750900269, 0.14383576810359955, 0.0, -0.010576209984719753, -0.17704203724861145, 0.0, 0.2212524116039276,
  ],
  [
    0.38294968008995056, 0.20491114258766174, -0.19836686551570892, 0.10453816503286362, 0.15512441098690033,
    -1.290454387664795, -0.4245958924293518, -0.2432953417301178, -0.7446008324623108, 0.022200992330908775,
    0.5687395334243774, -0.1536065638065338,
  ],
  [
    -0.5599173307418823, -2.025137424468994, 0.07224337011575699, -0.4482201933860779, -0.011443687602877617,
    -0.2755080759525299, -0.1635352075099945, -0.18555088341236115, 0.3247825801372528, -0.02839202992618084,
    -0.9778275489807129, -0.4620247781276703,
  ],
  [
    0.666183590888977, -0.17215825617313385, -0.45634132623672485, 0.7792296409606934, -0.04623838886618614,
    0.061253707855939865, 0.0022871471010148525, -0.3080037236213684, 0.003075069049373269, -0.36129704117774963,
    0.03871205076575279, -0.04742753133177757,
  ],
  [
    -0.4593365490436554, 0.17210900783538818, 0.21172815561294556, -0.2614692449569702, 0.0494903065264225,
    0.173391193151474, -0.04581891745328903, -0.1065671443939209, -0.24682152271270752, -0.4456157684326172,
    -0.10771918296813965, 0.1110352948307991,
  ],
  [
    -0.09154295921325684, 0.1020255908370018, -0.345159649848938, 0.3380209505558014, -0.3123515546321869,
    0.28007885813713074, -0.3538037836551666, -0.09459936618804932, -0.057955820113420486, 0.3511051535606384,
    -0.13168032467365265, -0.447246789932251,
  ],
  [
    -0.24321018159389496, -0.4660879075527191, -0.33007752895355225, 0.10662898421287537, -0.1517578810453415,
    0.4820071756839752, 0.47681403160095215, 0.31576988101005554, 0.3733810782432556, 0.12116821110248566,
    -0.40563061833381653, 0.06110553815960884,
  ],
  [
    -0.34311264753341675, -0.3325004279613495, -0.18299904465675354, -0.14547722041606903, 0.37737369537353516,
    -0.14519135653972626, 0.22954760491847992, -0.31975340843200684, 0.01822773739695549, 0.7159772515296936,
    -0.2279847264289856, 0.26809224486351013,
  ],
  [
    -0.1674133539199829, -0.39751553535461426, 0.3654388189315796, -0.41542816162109375, 0.31356537342071533,
    0.3273787498474121, 0.04349660873413086, 0.40836000442504883, -0.35569489002227783, -0.17370402812957764,
    0.41276419162750244, -0.09695994853973389,
  ],
  [
    -0.4864555597305298, -0.2866237163543701, 0.22404992580413818, 0.04459596425294876, 0.0627521499991417,
    0.06906472891569138, -0.4374849796295166, 0.1562718152999878, 0.25272634625434875, -0.4000082015991211,
    -0.1311742067337036, 0.04500460624694824,
  ],
  [
    -0.19459864497184753, -0.26363372802734375, -0.45926225185394287, -0.31905749440193176, -0.25066545605659485,
    -0.24797765910625458, 0.2967454493045807, 0.2761167287826538, 0.0009281057864427567, -0.0816931426525116,
    0.41745972633361816, 0.3018178939819336,
  ],
  [
    0.2752288579940796, 0.3833272457122803, -0.3875572681427002, 0.4553968906402588, 0.0007992982864379883,
    0.47031736373901367, -0.3314272165298462, 0.21664023399353027, 0.22501003742218018, 0.1784592866897583,
    -0.057346343994140625, 0.22068285942077637,
  ],
  [
    0.0805249959230423, 0.8487988710403442, -0.2148580551147461, -0.2625017464160919, 0.05316239595413208,
    0.08151575177907944, -0.10121412575244904, -0.2591831684112549, -0.2069038301706314, 0.12681084871292114,
    0.5971445441246033, -0.1304227113723755,
  ],
  [
    0.31813815236091614, -0.2728547751903534, -0.04096980392932892, 0.5929114818572998, 0.19339340925216675,
    0.5927548408508301, 0.37726590037345886, -0.03161739557981491, 0.41382578015327454, -0.05983201786875725,
    -0.276643306016922, -0.07282620668411255,
  ],
  [
    -0.10521074384450912, 0.26309365034103394, 0.06034649536013603, -0.20854416489601135, 0.06932162493467331,
    -0.1255345344543457, 0.10543252527713776, -0.2944018244743347, 0.3117785155773163, 0.11208368837833405,
    0.29044076800346375, 0.40696001052856445,
  ],
  [
    -0.09165162593126297, 0.10733765363693237, -0.304729163646698, -0.19172219932079315, -0.035441067069768906,
    -0.12447389215230942, 0.053304899483919144, -0.19871361553668976, 0.3068718910217285, 0.04426948353648186,
    0.16123993694782257, 0.16382718086242676,
  ],
  [
    -0.07869193702936172, 0.03167860954999924, 0.23047658801078796, -0.19295184314250946, -0.012200739234685898,
    -0.11031483858823776, -0.00543842650949955, -0.39264926314353943, 0.31115660071372986, -0.042936768382787704,
    0.07359152287244797, -0.291096568107605,
  ],
  [
    -0.024399448186159134, -0.001405909308232367, -0.23286683857440948, -0.11397019028663635, 0.013460791669785976,
    -0.08905310928821564, -0.1571386307477951, 0.5692389607429504, 0.33389395475387573, -0.027566026896238327,
    -0.006673417519778013, -0.11930350959300995,
  ],
  [
    -0.04745333269238472, -0.002939605852589011, -0.29839494824409485, -0.1296014040708542, -0.06207578256726265,
    -0.09065335988998413, -0.16152814030647278, -0.4389550983905792, 0.32229262590408325, -0.024892384186387062,
    0.009349143132567406, -0.27198565006256104,
  ],
  [
    -0.10504744201898575, 0.5058985948562622, 0.10158790647983551, -0.2179396152496338, 0.25347691774368286,
    -0.12462744861841202, 0.17027918994426727, 0.3447275757789612, 0.3245198130607605, 0.1865157186985016,
    0.46706438064575195, -0.38155168294906616,
  ],
  [
    0.10832405835390091, 0.10832405835390091, 0.10832405835390091, 0.10832405835390091, 0.10832405835390091,
    0.10832405835390091, 0.10832405835390091, 0.10832405835390091, 0.10832405835390091, 0.10832405835390091,
    0.10832405835390091, 0.10832405835390091,
  ],
  [
    0.12808172404766083, 0.12808172404766083, 0.12808172404766083, 0.12808172404766083, 0.12808172404766083,
    0.12808172404766083, 0.12808172404766083, 0.12808172404766083, 0.12808172404766083, 0.12808172404766083,
    0.12808172404766083, 0.12808172404766083,
  ],
  [
    0.12207086384296417, 0.12207086384296417, 0.12207086384296417, 0.12207086384296417, 0.12207086384296417,
    0.12207086384296417, 0.12207086384296417, 0.12207086384296417, 0.12207086384296417, 0.12207086384296417,
    0.12207086384296417, 0.12207086384296417,
  ],
  [
    0.06873062252998352, 0.06873062252998352, 0.06873062252998352, 0.06873062252998352, 0.06873062252998352,
    0.06873062252998352, 0.06873062252998352, 0.06873062252998352, 0.06873062252998352, 0.06873062252998352,
    0.06873062252998352, 0.06873062252998352,
  ],
  [
    0.10726658999919891, 0.10726658999919891, 0.10726658999919891, 0.10726658999919891, 0.10726658999919891,
    0.10726658999919891, 0.10726658999919891, 0.10726658999919891, 0.10726658999919891, 0.10726658999919891,
    0.10726658999919891, 0.10726658999919891,
  ],
  [
    0.060458313673734665, 0.060458313673734665, 0.060458313673734665, 0.060458313673734665, 0.060458313673734665,
    0.060458313673734665, 0.060458313673734665, 0.060458313673734665, 0.060458313673734665, 0.060458313673734665,
    0.060458313673734665, 0.060458313673734665,
  ],
];

export const MARC_L8_XAP = [
  [
    -2.668578863143921, 0.1129852905869484, 1.4612219333648682, -0.3754354417324066, 0.003544769948348403,
    -0.3681684732437134, -0.4516613483428955, 0.7079740166664124, 0.9757131338119507, 1.7526804208755493,
    -0.08752751350402832, -0.13062751293182373,
  ],
  [
    -0.19664576649665833, -0.31933319568634033, 0.45418572425842285, -0.48102468252182007, 0.5151981711387634,
    -0.5032984614372253, -0.027369888499379158, 0.7582165002822876, 0.5091027617454529, -0.29083842039108276,
    -0.10149071365594864, -0.003362498711794615,
  ],
  [
    -0.0012657559709623456, 0.26320862770080566, 0.0018249036511406302, 0.36095210909843445, 1.4502833437290974e-5,
    -0.0004897361504845321, 0.0018980363383889198, 0.0014638545690104365, -0.0007023443467915058,
    -0.0007148247677832842, 0.0017924270359799266, 0.02731727436184883,
  ],
  [
    0.48200491070747375, 0.2534983158111572, -0.6969249844551086, -0.3012285828590393, -0.5654635429382324,
    1.0256232023239136, 0.6522439122200012, -1.0437134504318237, -0.3238515257835388, -0.011421640403568745,
    1.0771957635879517, -0.3472261130809784,
  ],
  [
    -0.0021253060549497604, -0.2612258195877075, -0.041548941284418106, -0.397238165140152, -0.0028847253415733576,
    -0.035895366221666336, 0.01867314614355564, 0.004552134312689304, 0.021292714402079582, -0.019061187282204628,
    -0.0325310118496418, 0.02108607068657875,
  ],
  [
    0.047864604741334915, -0.5958683490753174, -0.3853602707386017, 0.18639476597309113, 0.4979681670665741,
    0.30820944905281067, -0.08027302473783493, -0.040349721908569336, -0.10120275616645813, 0.3081539273262024,
    -0.11724254488945007, 0.03901410102844238,
  ],
  [
    -0.003600821830332279, -0.49780818819999695, 0.2111169844865799, 0.15713591873645782, 0.12272650003433228,
    0.13484840095043182, -0.12166208028793335, 0.04595493897795677, -0.026902461424469948, 0.005773782730102539,
    0.11899542063474655, -0.5628054141998291,
  ],
  [
    0.38939836621284485, -0.17540012300014496, 0.32901155948638916, -0.07283063232898712, -0.02379726991057396,
    0.3764100670814514, 0.25930720567703247, -0.16797195374965668, -0.16937218606472015, 0.04518961161375046,
    0.19328433275222778, -0.026337649673223495,
  ],
  [
    -0.4077988862991333, -0.10331790894269943, -0.2588936686515808, 0.37678396701812744, -0.44950151443481445,
    0.07245177775621414, -0.4775969982147217, -0.7069081664085388, 0.038353800773620605, 0.15706396102905273,
    0.05761289596557617, 0.2312958538532257,
  ],
  [
    -0.19839024543762207, 0.016215108335018158, -0.4842585325241089, -0.017766594886779785, -0.21736454963684082,
    0.1930752694606781, 0.17788568139076233, 0.36036238074302673, -0.11073076725006104, -0.1583142727613449,
    -0.060943059623241425, 0.35822880268096924,
  ],
  [
    -0.21802544593811035, -0.6163607239723206, 0.4332333207130432, 0.042963385581970215, -0.3955690860748291,
    -0.42623189091682434, 0.1304929107427597, 0.5181683301925659, -0.08537018299102783, -0.4443719983100891,
    0.06337906420230865, -1.2825558185577393,
  ],
  [
    -0.20813918113708496, -0.4442707896232605, -0.04106724262237549, -0.17596495151519775, -0.030700325965881348,
    -0.42544126510620117, 0.0690004825592041, 0.0653185248374939, -0.028287053108215332, 0.18293561041355133,
    -0.2733135223388672, 0.15549302101135254,
  ],
  [
    0.3073430061340332, -0.6058445572853088, 0.20240767300128937, 0.0014287233352661133, -0.035216450691223145,
    -0.08049222081899643, -0.5396603345870972, 0.0008023881819099188, 0.28777945041656494, -0.25518253445625305,
    -0.6068628430366516, 1.7401247024536133,
  ],
  [
    -0.37972986698150635, 0.19864428043365479, -0.23237882554531097, -0.45459234714508057, -0.33098816871643066,
    -0.3688730299472809, -0.34993496537208557, 0.35916218161582947, -0.47528743743896484, 0.5585456490516663,
    -0.34616485238075256, 0.7957710027694702,
  ],
  [
    0.0572589635848999, 0.3441958427429199, -0.3761991560459137, 0.08681237697601318, -0.055370450019836426,
    -0.032844178378582, 0.135483980178833, -0.22249852120876312, -0.4377373456954956, 0.285955011844635,
    -0.3519173860549927, 0.20658978819847107,
  ],
  [
    -0.06260037422180176, 0.6836893558502197, -0.424175888299942, -0.28834080696105957, -0.24949872493743896,
    -0.013240694999694824, -0.35756146907806396, 0.08790842443704605, -0.17019248008728027, 0.4439167082309723,
    0.018093522638082504, -0.0718725398182869,
  ],
  [
    -0.2161182165145874, -0.028761476278305054, -0.0803091898560524, -0.195686936378479, -0.13666248321533203,
    -0.4237534701824188, -0.04511057212948799, -0.03407219052314758, -0.44998133182525635, -0.1967076063156128,
    0.004792934283614159, -0.24161101877689362,
  ],
  [
    -0.3323655128479004, 0.405803918838501, -0.10540107637643814, 0.18673646450042725, 0.294844388961792,
    0.19420276582241058, 0.2847100794315338, 0.43863826990127563, -0.32141613960266113, -0.146721750497818,
    0.1240650936961174, 0.5473235249519348,
  ],
  [
    -0.24425947666168213, 0.5043827891349792, -0.5617842078208923, -0.18791115283966064, -0.19809603691101074,
    0.14481325447559357, -0.3448881506919861, 0.013367426581680775, 0.12491190433502197, 0.5274604558944702,
    -0.4357273578643799, -0.43788591027259827,
  ],
  [
    -0.48424720764160156, 0.3755701184272766, -0.46423307061195374, -0.19668316841125488, -0.17900919914245605,
    0.3642078638076782, 0.12320029735565186, -0.43929436802864075, 0.045519232749938965, 0.39266765117645264,
    -0.33261191844940186, -0.23393018543720245,
  ],
  [
    0.0, 0.2229820340871811, 0.870395839214325, 0.0, 0.0, -0.050845012068748474, -0.06269064545631409,
    0.06251555681228638, 0.0, 0.35824236273765564, -0.1476883441209793, -0.24767015874385834,
  ],
  [
    -0.07774519920349121, -0.3411388397216797, -0.17939281463623047, -0.21156466007232666, 0.07495510578155518,
    -0.4511507749557495, -0.29627537727355957, -0.00032389163970947266, 0.28086090087890625, -0.21700060367584229,
    0.13287103176116943, -0.0563429594039917,
  ],
  [
    0.5884438753128052, -0.4350554049015045, -0.18197286128997803, 0.12389452010393143, -0.23529797792434692,
    -0.13616536557674408, -0.17778965830802917, -0.08909228444099426, -0.17428576946258545, -0.2700452208518982,
    -0.03275277465581894, -0.14896196126937866,
  ],
  [
    0.7411401271820068, 0.23029422760009766, -0.2885967493057251, 0.5268824100494385, 0.5745720267295837,
    0.5731266736984253, 0.23465001583099365, 1.0522304773330688, -0.4803982973098755, 0.06223946437239647,
    -0.24674461781978607, -0.21334856748580933,
  ],
  [
    0.3591310977935791, -0.21008121967315674, -0.22733330726623535, 0.23509716987609863, -0.4393254518508911,
    -0.09758508205413818, -0.23168301582336426, 0.3599895238876343, -0.37953031063079834, 0.20059776306152344,
    0.4797769784927368, -0.0048122406005859375,
  ],
  [
    -0.4013129472732544, -0.17592179775238037, -0.48076117038726807, 0.051888108253479004, 0.06285595893859863,
    0.27560949325561523, -0.38456666469573975, -0.012967586517333984, -0.04133129119873047, 0.3705188035964966,
    0.2448340654373169, -0.15055906772613525,
  ],
  [
    0.3008756935596466, 0.37619659304618835, -0.33046698570251465, -0.09246329963207245, 0.14435841143131256,
    -0.07498340308666229, 0.2206820845603943, 0.2720984220504761, -0.32016241550445557, 0.1197228655219078,
    -0.3320336937904358, 0.15974745154380798,
  ],
  [
    0.1959906369447708, 0.1358896940946579, 0.07853949069976807, 0.27794843912124634, 0.024458473548293114,
    0.015632985159754753, -0.3839518427848816, 0.10006722807884216, -0.35995233058929443, 0.014342065900564194,
    -0.32010114192962646, 0.40859320759773254,
  ],
  [
    -0.01928669400513172, -0.21459375321865082, -0.2685030698776245, 0.21644940972328186, 0.33643946051597595,
    -2.417978525161743, -0.07117880135774612, -0.2265867441892624, -0.27091073989868164, -0.8516976833343506,
    0.17523504793643951, 0.1699276566505432,
  ],
  [
    -0.26793110370635986, -0.00914144515991211, 0.083382248878479, -0.13821709156036377, -0.48083066940307617,
    0.15635371208190918, -0.07507312297821045, -0.20190811157226562, 0.30896055698394775, -0.03788626194000244,
    0.22693169116973877, 0.250593900680542,
  ],
  [
    0.39137765765190125, 0.7570663690567017, -0.3313632011413574, 0.2994733154773712, 0.2236287146806717,
    0.34518736600875854, 0.5866767168045044, 0.5082213878631592, -0.3482344150543213, 0.4548341929912567,
    0.39995265007019043, -0.47514572739601135,
  ],
  [
    0.2880750894546509, 0.24523711204528809, 0.3201810121536255, 0.3437897861003876, 0.06123386695981026,
    0.020122885704040527, -0.4110715389251709, 0.2109435498714447, 0.23026609420776367, 0.08684313297271729,
    -0.2114792913198471, -0.23885560035705566,
  ],
  [
    0.02627866342663765, -0.6750727295875549, -0.25105059146881104, -0.5125012993812561, 0.11498252302408218,
    0.24202075600624084, 0.9269174933433533, 0.020474873483181, 0.3701770305633545, 0.08769018203020096,
    0.041787032037973404, 0.3444633483886719,
  ],
  [
    -0.7930895686149597, -0.19708992540836334, 0.0, -0.6833093762397766, -0.1409347951412201, 0.33365094661712646,
    -0.18181532621383667, -0.7340786457061768, 0.0, 0.3292475640773773, 0.12644249200820923, -0.1669745147228241,
  ],
  [
    0.7297701835632324, 0.07892856001853943, -0.5300710201263428, 0.30496859550476074, -0.3644580841064453,
    0.007980328984558582, 0.054397232830524445, -0.09902267158031464, 0.10342705249786377, 0.010554364882409573,
    0.20084209740161896, -0.349467396736145,
  ],
  [
    0.6007967591285706, 0.12626907229423523, 0.35760271549224854, 0.17272807657718658, -0.28032705187797546,
    0.023550191894173622, 0.11558280140161514, -0.0851888358592987, -0.429148405790329, 0.020993612706661224,
    0.23612141609191895, 0.35971584916114807,
  ],
  [
    0.2445746511220932, 0.0766729936003685, -0.2358180284500122, 0.015123247168958187, -0.1341981142759323,
    0.10194723308086395, 0.2357897013425827, -0.02505708485841751, -0.3159346580505371, 0.09550709277391434,
    0.18518684804439545, -0.47571492195129395,
  ],
  [
    0.21900911629199982, 0.18412885069847107, 0.05110293626785278, 0.04983129724860191, -0.1749711036682129,
    0.07540613412857056, 0.26099708676338196, -0.07609231770038605, -0.5122244954109192, 0.07617621123790741,
    0.19308030605316162, -0.5020527243614197,
  ],
  [
    0.19897174835205078, 0.444497674703598, -0.30093011260032654, -0.037612903863191605, -0.14910930395126343,
    -0.0012261770898476243, 0.2811909317970276, -0.18144671618938446, -0.14252179861068726, 0.06852536648511887,
    0.26813891530036926, -0.09073356539011002,
  ],
  [
    -0.07538489997386932, 0.3976171910762787, -0.11258205771446228, 0.1292678862810135, -0.20209111273288727,
    0.13142679631710052, 0.24530857801437378, -0.18980951607227325, 0.3374425172805786, 0.34521010518074036,
    0.08567173033952713, 0.02147970162332058,
  ],
  [
    -0.04192051291465759, 0.2033178061246872, 0.30696791410446167, 0.4480690062046051, -0.35389843583106995,
    0.25597691535949707, 0.1381416767835617, -0.19001613557338715, -0.2440897822380066, 0.350248247385025,
    -0.10845547914505005, -0.050866320729255676,
  ],
  [
    0.2840818762779236, 0.2840818762779236, 0.2840818762779236, 0.2840818762779236, 0.2840818762779236,
    0.2840818762779236, 0.2840818762779236, 0.2840818762779236, 0.2840818762779236, 0.2840818762779236,
    0.2840818762779236, 0.2840818762779236,
  ],
  [
    0.22369250655174255, 0.22369250655174255, 0.22369250655174255, 0.22369250655174255, 0.22369250655174255,
    0.22369250655174255, 0.22369250655174255, 0.22369250655174255, 0.22369250655174255, 0.22369250655174255,
    0.22369250655174255, 0.22369250655174255,
  ],
  [
    0.11581744253635406, 0.11581744253635406, 0.11581744253635406, 0.11581744253635406, 0.11581744253635406,
    0.11581744253635406, 0.11581744253635406, 0.11581744253635406, 0.11581744253635406, 0.11581744253635406,
    0.11581744253635406, 0.11581744253635406,
  ],
  [
    0.15066170692443848, 0.15066170692443848, 0.15066170692443848, 0.15066170692443848, 0.15066170692443848,
    0.15066170692443848, 0.15066170692443848, 0.15066170692443848, 0.15066170692443848, 0.15066170692443848,
    0.15066170692443848, 0.15066170692443848,
  ],
  [
    0.13786724209785461, 0.13786724209785461, 0.13786724209785461, 0.13786724209785461, 0.13786724209785461,
    0.13786724209785461, 0.13786724209785461, 0.13786724209785461, 0.13786724209785461, 0.13786724209785461,
    0.13786724209785461, 0.13786724209785461,
  ],
  [
    0.1798412948846817, 0.1798412948846817, 0.1798412948846817, 0.1798412948846817, 0.1798412948846817,
    0.1798412948846817, 0.1798412948846817, 0.1798412948846817, 0.1798412948846817, 0.1798412948846817,
    0.1798412948846817, 0.1798412948846817,
  ],
  [
    0.2876674234867096, 0.2876674234867096, 0.2876674234867096, 0.2876674234867096, 0.2876674234867096,
    0.2876674234867096, 0.2876674234867096, 0.2876674234867096, 0.2876674234867096, 0.2876674234867096,
    0.2876674234867096, 0.2876674234867096,
  ],
];

export const MARC_L8_XBP = [
  [
    -0.6193560361862183, 1.405318021774292, -0.3085975646972656, -0.6060299277305603, -0.5162925124168396,
    1.3764605522155762, 0.27593526244163513, -0.13851486146450043, -0.5504883527755737, -2.634782314300537,
    -0.36995476484298706, 0.59542316198349,
  ],
  [
    -0.894524335861206, 1.2800956964492798, 0.3929189443588257, -0.6320793628692627, 0.15803851187229156,
    0.6053783297538757, 0.8149197697639465, -1.0997684001922607, -0.06728141754865646, 0.654589056968689,
    -0.22532442212104797, -0.7745215892791748,
  ],
  [
    0.012883252464234829, 0.1487961858510971, -0.2694052755832672, -0.018656263127923012, -0.5401819944381714,
    -0.07077401876449585, -0.0807255357503891, -0.38624057173728943, 0.9671037793159485, -0.057538531720638275,
    0.004609064664691687, 0.19731958210468292,
  ],
  [
    0.9623440504074097, -0.5452277064323425, -0.4080936014652252, 0.6505317687988281, 0.0951954647898674,
    -5.43837308883667, 0.020143505185842514, 0.06826910376548767, 0.859133243560791, 0.335808664560318,
    1.385245680809021, 0.01911661960184574,
  ],
  [
    -0.00203489582054317, -0.007004592102020979, -0.44848358631134033, -0.002796393120661378, 0.028024761006236076,
    -0.0011315559968352318, 0.001535999123007059, -0.0026875094044953585, 0.014057407155632973, -0.0005951690836809576,
    0.0008743453654460609, -0.0014683600747957826,
  ],
  [
    0.0030681025236845016, 0.0024455536622554064, -0.5345066785812378, -0.00029801332857459784, -0.48892340064048767,
    -0.006279807537794113, 0.002678971504792571, 0.0013026436790823936, 0.009047691710293293, 0.005398894194513559,
    0.002074909396469593, -0.0010607456788420677,
  ],
  [
    -0.09170432388782501, -0.04572870209813118, -0.5942254662513733, -0.07115364074707031, -0.3086475729942322,
    0.3523406386375427, 0.39078792929649353, 0.11991187930107117, 0.2445453256368637, 0.021616285666823387,
    -0.09090837091207504, 0.03391000255942345,
  ],
  [
    0.37649139761924744, -0.6176439523696899, -0.06406521052122116, 0.7424095869064331, -0.1006372720003128,
    0.3453875780105591, -0.6733893156051636, 1.1156803369522095, -0.5158007144927979, -0.12134301662445068,
    -0.01799410581588745, 0.5998204946517944,
  ],
  [
    0.38713154196739197, 0.42569783329963684, 0.21251080930233002, 0.24757184088230133, 0.17825613915920258,
    0.5104182958602905, -0.3223649263381958, -0.14796827733516693, -0.4494863450527191, -0.47755733132362366,
    0.7486376166343689, 0.015831012278795242,
  ],
  [
    -1.1507277488708496, -1.6282269954681396, 0.9282038807868958, 1.115764856338501, -0.36188340187072754,
    -2.597217321395874, -0.2027750015258789, -0.514220118522644, -0.1890692114830017, 0.03225922957062721,
    -0.07921729236841202, -0.42750614881515503,
  ],
  [
    -0.2733217179775238, 0.4146710932254791, 0.23778486251831055, -0.328830748796463, 0.10684061050415039,
    -0.042450278997421265, -0.3265906572341919, 0.07027685642242432, 0.11610402911901474, 0.15634095668792725,
    0.23956546187400818, 0.37112152576446533,
  ],
  [
    0.5154199600219727, 0.32534879446029663, -0.24277864396572113, 0.009149317629635334, 0.2796594798564911,
    0.678589403629303, 0.27237260341644287, 0.4856000244617462, 0.6096274852752686, 0.9039009809494019,
    0.6903276443481445, 0.5091246962547302,
  ],
  [
    0.2409326434135437, -0.028448062017560005, -0.46185481548309326, 0.25952303409576416, 0.04076659679412842,
    0.13063007593154907, 0.03426778316497803, -0.34911003708839417, -0.05580761283636093, 0.24824821949005127,
    -0.5091689229011536, -0.3502258062362671,
  ],
  [
    -0.3847281336784363, -0.13062582910060883, -0.5906466245651245, -0.5437778234481812, -0.3583667278289795,
    0.3626622259616852, -0.3928592801094055, -0.09873181581497192, -0.18625600636005402, -0.005554925184696913,
    -0.04821483790874481, 0.9939667582511902,
  ],
  [
    -0.7440980076789856, -0.9732158184051514, -0.13056132197380066, 0.7502586245536804, 0.2687664031982422,
    -0.20295634865760803, 0.19944563508033752, -0.18977338075637817, 0.10918044298887253, -1.0747991800308228,
    -0.07541845738887787, -0.19126734137535095,
  ],
  [
    2.187631845474243, -0.14565438032150269, -0.17839159071445465, -0.08787794411182404, 0.37100666761398315,
    3.625701665878296, 0.3768530488014221, 0.66461181640625, -0.08268678933382034, 0.1311061978340149,
    0.13060395419597626, -0.13472041487693787,
  ],
  [
    -0.0801558643579483, 0.4935573637485504, -0.052233826369047165, -0.026249613612890244, -0.5190181136131287,
    -1.0120611190795898, 0.3280651569366455, -0.011191598139703274, 0.17128854990005493, 0.5970285534858704,
    0.04421313852071762, 0.08467740565538406,
  ],
  [
    -0.5255730748176575, 0.8429344892501831, 0.00478905625641346, -0.43894848227500916, -0.4963195025920868,
    -0.592042863368988, -0.42401766777038574, -0.3497686982154846, 0.6776617169380188, 0.1925533413887024,
    0.06211115047335625, -0.12493909895420074,
  ],
  [
    0.05108439922332764, 0.2484212964773178, 0.16548237204551697, 0.4458290934562683, -0.16650167107582092,
    0.033345770090818405, -0.4329855740070343, 0.17195558547973633, -0.04535800591111183, -0.6473079919815063,
    0.8185559511184692, -0.5018882751464844,
  ],
  [
    -0.648690402507782, -0.6242476105690002, -0.24576406180858612, 0.25560519099235535, 0.14147229492664337,
    -0.659241795539856, -0.19669272005558014, -0.2731434106826782, -0.6771666407585144, 1.333377480506897,
    0.07928118854761124, 0.9088529348373413,
  ],
  [
    0.4956866204738617, -0.31427809596061707, -0.050501398742198944, -0.5687734484672546, -0.0595894418656826,
    0.3404090106487274, -0.12839558720588684, 0.41855281591415405, 0.05558449402451515, -0.36989131569862366,
    0.18672306835651398, 0.31105583906173706,
  ],
  [
    0.2820253372192383, 0.6184027791023254, 0.07914005219936371, -0.11727793514728546, 0.09774194657802582,
    -0.6201218366622925, -0.49119970202445984, 0.21781904995441437, 0.004787245765328407, -0.20369970798492432,
    0.01894226111471653, -0.4521147608757019,
  ],
  [
    0.3648722171783447, -0.1381940394639969, -0.36409449577331543, 0.32431164383888245, 0.3948025405406952,
    0.4519999623298645, -0.2563205361366272, -0.5949133634567261, -0.06204124167561531, -0.6570523381233215,
    -0.17491786181926727, -0.5424018502235413,
  ],
  [
    -0.1161179468035698, -1.8621927499771118, 0.22824741899967194, -0.281522661447525, 0.6139042377471924,
    0.25937020778656006, -0.24807681143283844, -1.4162044525146484, 0.04542624205350876, -0.7018172144889832,
    -0.1775580495595932, -0.4356996715068817,
  ],
  [
    -0.043990831822156906, -3.668264865875244, -0.07590188086032867, -0.29788678884506226, -0.35477325320243835,
    0.1089232936501503, 0.24000687897205353, -1.0770200490951538, 0.027183856815099716, -0.4480020999908447,
    -0.24936462938785553, 0.07516461610794067,
  ],
  [
    -0.04207979515194893, -0.141556054353714, 0.2054746150970459, -0.09472998231649399, -0.14976751804351807,
    0.3989320993423462, -0.3836376667022705, 0.2922692894935608, -0.2661985754966736, -0.16512158513069153,
    -0.35052990913391113, -0.2902315855026245,
  ],
  [
    0.2921495735645294, 0.8820160627365112, -0.3184215724468231, 0.20893757045269012, 0.20523184537887573,
    0.3277895450592041, -0.9903225302696228, -0.6274891495704651, 0.1863703578710556, 0.28345754742622375,
    0.05748211592435837, 0.033150553703308105,
  ],
  [
    -0.18578246235847473, 0.12911801040172577, 0.23552076518535614, -0.2583570182323456, 0.13944315910339355,
    -0.2193063497543335, -0.016639377921819687, -0.3005642890930176, 0.23031775653362274, -0.12657079100608826,
    -0.21829193830490112, 0.4500305950641632,
  ],
  [
    0.26354870200157166, 0.9625835418701172, -0.13304920494556427, -0.688228189945221, 0.06898308545351028,
    -0.18321262300014496, -1.0330889225006104, 0.26734790205955505, -0.03452920541167259, 0.2046145349740982,
    -0.29455631971359253, 0.09121143072843552,
  ],
  [
    0.3997794985771179, 1.0351827144622803, 0.16708770394325256, 0.08832305669784546, 0.3740710914134979,
    0.20636476576328278, 0.4373254179954529, -0.009983389638364315, 0.5632763504981995, -0.7267720103263855,
    -0.28809019923210144, -0.13482418656349182,
  ],
  [
    -0.0035029093269258738, -0.6944049596786499, -0.1684999167919159, 0.17094270884990692, 0.04708543047308922,
    -0.18490327894687653, 0.5478940010070801, 0.0493604801595211, -0.08735688775777817, -0.02283508889377117,
    0.26724934577941895, -0.18896067142486572,
  ],
  [
    0.06573779881000519, -0.22393138706684113, -0.40004029870033264, 0.3953167796134949, 0.2571203112602234,
    0.046790093183517456, 0.446903795003891, 0.049663983285427094, -0.5058923363685608, 0.2582118809223175,
    0.5033558011054993, 0.13899950683116913,
  ],
  [
    -0.13368701934814453, -3.6098456382751465, 0.2294618785381317, -0.1343974769115448, 0.16202323138713837,
    0.37122541666030884, 0.08251391351222992, -1.797298550605774, 0.14150243997573853, -0.7583993077278137,
    -0.307038277387619, -0.1395339071750641,
  ],
  [
    0.13666954636573792, 0.932353138923645, 0.1300460249185562, 0.08796054124832153, -0.2322228103876114,
    -0.5185433030128479, -0.40047764778137207, 1.0402908325195312, 0.7913020849227905, 0.5238310098648071,
    -0.2648638188838959, -0.17603328824043274,
  ],
  [
    0.21595779061317444, 0.0016321216244250536, 0.14911387860774994, 0.08630091696977615, 0.2546226978302002,
    0.05916179344058037, 0.004487632308155298, 0.0037483118940144777, -0.3987807631492615, 0.07458410412073135,
    0.2835805118083954, -0.17688509821891785,
  ],
  [
    0.300025999546051, 0.0020795967429876328, 0.12329775840044022, 0.11341257393360138, 0.14061596989631653,
    0.06172947213053703, 0.01410168968141079, 0.009721560403704643, -0.3712368607521057, 0.08824768662452698,
    0.2225010246038437, -0.39490845799446106,
  ],
  [
    0.40355953574180603, 0.00433338200673461, 0.07697522640228271, 0.11857099831104279, 0.013352159410715103,
    0.0658334419131279, 0.021555138751864433, 0.01955493539571762, -0.3138905167579651, 0.11335242539644241,
    0.14972683787345886, 0.365094929933548,
  ],
  [
    0.44154971837997437, 0.00804976373910904, 0.026342961937189102, 0.0469072125852108, -0.002190257189795375,
    0.06889647990465164, 0.015300922095775604, 0.026813911274075508, -0.24813660979270935, 0.1369292438030243,
    0.12432932108640671, 0.2925068140029907,
  ],
  [
    0.4853890538215637, 0.01946246437728405, -0.04911200702190399, -0.0304705873131752, -0.035923365503549576,
    0.05744538828730583, 0.034717559814453125, 0.050910837948322296, -0.12361842393875122, 0.17227144539356232,
    0.06545209139585495, 0.1058984100818634,
  ],
  [
    0.3471737205982208, 0.06059407815337181, -0.11138385534286499, 0.08586181700229645, -0.008656326681375504,
    0.03458279371261597, 0.0782642662525177, 0.11766340583562851, 0.02125927060842514, 0.14319393038749695,
    -0.030355991795659065, -0.29776731133461,
  ],
  [
    0.26741665601730347, 0.07661154866218567, -0.08609093725681305, 0.17957556247711182, 0.016019748523831367,
    0.01966378465294838, 0.04447465389966965, 0.11200058460235596, 0.02517547830939293, 0.07289904356002808,
    -0.07053003460168839, -0.17852561175823212,
  ],
  [
    0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817,
    0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817, 0.338452011346817,
  ],
  [
    0.3207853138446808, 0.3207853138446808, 0.3207853138446808, 0.3207853138446808, 0.3207853138446808,
    0.3207853138446808, 0.3207853138446808, 0.3207853138446808, 0.3207853138446808, 0.3207853138446808,
    0.3207853138446808, 0.3207853138446808,
  ],
  [
    0.28123539686203003, 0.28123539686203003, 0.28123539686203003, 0.28123539686203003, 0.28123539686203003,
    0.28123539686203003, 0.28123539686203003, 0.28123539686203003, 0.28123539686203003, 0.28123539686203003,
    0.28123539686203003, 0.28123539686203003,
  ],
  [
    0.23609325289726257, 0.23609325289726257, 0.23609325289726257, 0.23609325289726257, 0.23609325289726257,
    0.23609325289726257, 0.23609325289726257, 0.23609325289726257, 0.23609325289726257, 0.23609325289726257,
    0.23609325289726257, 0.23609325289726257,
  ],
  [
    0.14488372206687927, 0.14488372206687927, 0.14488372206687927, 0.14488372206687927, 0.14488372206687927,
    0.14488372206687927, 0.14488372206687927, 0.14488372206687927, 0.14488372206687927, 0.14488372206687927,
    0.14488372206687927, 0.14488372206687927,
  ],
  [
    0.028635190799832344, 0.028635190799832344, 0.028635190799832344, 0.028635190799832344, 0.028635190799832344,
    0.028635190799832344, 0.028635190799832344, 0.028635190799832344, 0.028635190799832344, 0.028635190799832344,
    0.028635190799832344, 0.028635190799832344,
  ],
  [
    0.014143895357847214, 0.014143895357847214, 0.014143895357847214, 0.014143895357847214, 0.014143895357847214,
    0.014143895357847214, 0.014143895357847214, 0.014143895357847214, 0.014143895357847214, 0.014143895357847214,
    0.014143895357847214, 0.014143895357847214,
  ],
];

export const MARC_L8_XCP = [
  [
    0.0007336073904298246, 0.0008020814857445657, 0.007085217162966728, -0.0008513557258993387, 0.1660565435886383,
    -0.008153405971825123, 4.2980732359865215e-6, -0.4807538688182831, -0.0012605574447661638, -0.08867551386356354,
    0.32689368724823, 0.00022231608454603702,
  ],
  [
    0.0015608672983944416, -0.00037849368527531624, -0.19166210293769836, 0.0040339999832212925, -0.5845451951026917,
    0.23612284660339355, -0.0008312477730214596, -0.43597427010536194, 0.003941833972930908, -0.15178415179252625,
    -0.4954695403575897, -0.0009104844066314399,
  ],
  [
    0.0009634676389396191, 0.0007536461926065385, 0.09793323278427124, 0.0009304909617640078, 0.28861337900161743,
    -0.12058226764202118, 7.452016689057928e-6, -0.4961877763271332, -0.0006030839285813272, -0.036157965660095215,
    -0.45246848464012146, -4.592266122926958e-7,
  ],
  [
    -0.8893182873725891, 0.9226959347724915, 1.4400634765625, -1.0912524461746216, -0.24018460512161255,
    1.3551111221313477, -0.004984929226338863, 0.12728190422058105, 0.46537384390830994, -0.6896288990974426,
    0.03499356657266617, -2.126673460006714,
  ],
  [
    -0.00026554163196124136, -0.0012127930531278253, 0.09377092868089676, -0.0012706650886684656, -0.11988025158643723,
    -0.1157284751534462, -0.0017134204972535372, -0.3292798399925232, -0.0014321553753688931, -0.027399346232414246,
    0.20253734290599823, 7.794810517225415e-5,
  ],
  [
    0.0002573625242803246, -0.0007064453675411642, -0.0027453498914837837, 2.7027357418774045e-7, -0.13707272708415985,
    0.004163575358688831, -0.00035442152875475585, 0.5397981405258179, 0.0004304203321225941, 0.2801678776741028,
    -0.516615629196167, -0.00037973865983076394,
  ],
  [
    -0.7827543616294861, 0.41597476601600647, 0.09075847268104553, 0.14924879372119904, 0.2659569978713989,
    -0.054754674434661865, 0.7651690244674683, 0.1685926467180252, -0.8482890725135803, -0.14031532406806946,
    0.005624143406748772, 0.26593661308288574,
  ],
  [
    0.6180429458618164, -0.16847887635231018, 0.15491841733455658, 0.7288284301757812, -0.09052150696516037,
    0.03471958637237549, -0.15654712915420532, -0.021209482103586197, 0.48737579584121704, 0.01876187138259411,
    -0.043980326503515244, 0.5133500695228577,
  ],
  [
    -0.09789043664932251, 0.3085542321205139, -0.40020477771759033, -0.39961764216423035, -0.23836447298526764,
    0.006194880232214928, -0.25474220514297485, 0.980197012424469, 0.1675751805305481, 0.37975794076919556,
    -0.129128098487854, -0.09412851929664612,
  ],
  [
    -0.2677580714225769, -0.15281425416469574, -0.3669518828392029, -0.38003167510032654, -0.15302377939224243,
    -0.16781924664974213, 0.8377302885055542, 1.072722315788269, -0.040635183453559875, -0.1303071826696396,
    0.1430337131023407, -0.4834888279438019,
  ],
  [
    0.3329082727432251, -0.17888864874839783, 0.22959451377391815, -1.0930845737457275, 0.36520856618881226,
    0.367936372756958, -0.1991221159696579, -0.3312776982784271, 0.4192652106285095, 0.1830895096063614,
    -0.45050543546676636, 0.06351220607757568,
  ],
  [
    0.1460399329662323, -0.5882570743560791, 0.20508922636508942, 0.6418206691741943, -0.22042405605316162,
    -0.3104313910007477, 0.263479083776474, -0.0649905875325203, -0.13481749594211578, -0.37015530467033386,
    0.3806607127189636, 0.1333838850259781,
  ],
  [
    0.22568458318710327, -0.3926520049571991, -0.06534804403781891, 0.2573540508747101, 0.045138951390981674,
    0.38238751888275146, 0.14100590348243713, -0.3780312240123749, -0.18667323887348175, 0.26364320516586304,
    0.2677973508834839, 0.3760095238685608,
  ],
  [
    0.2653120756149292, -0.1477532833814621, -0.5156303644180298, -0.8945016860961914, 0.29600292444229126,
    0.3019765317440033, -0.16392090916633606, -0.27690261602401733, 0.33558177947998047, 0.14524689316749573,
    -0.367861270904541, 0.04045097529888153,
  ],
  [
    0.5949556827545166, 0.07004973292350769, -0.3601945638656616, 0.06931805610656738, 0.1959191858768463,
    -0.03573562577366829, 0.03379780054092407, 0.36396995186805725, 0.14817911386489868, 0.6747956275939941,
    0.09290937334299088, 0.5311385989189148,
  ],
  [
    0.12087824940681458, -0.12617215514183044, -0.31948089599609375, -0.18893635272979736, 0.21494193375110626,
    -0.12761190533638, 0.41602495312690735, 0.04749279096722603, 0.23948071897029877, -0.3796679973602295,
    -0.02382824756205082, -0.00816256646066904,
  ],
  [
    0.226861834526062, 0.11386603862047195, -0.15829449892044067, 0.33225294947624207, 0.07403458654880524,
    -0.19499221444129944, 0.1469600796699524, 0.43577930331230164, 0.4750688374042511, -0.06984832137823105,
    0.033042535185813904, 0.9870936274528503,
  ],
  [
    0.10495111346244812, 0.3379706144332886, -0.10167503356933594, 0.03851928189396858, 0.022072583436965942,
    -0.14219143986701965, -0.07166885584592819, 0.03595995157957077, -0.08192221075296402, 0.16909120976924896,
    0.0039241742342710495, 0.1115037277340889,
  ],
  [
    0.2825187146663666, 0.45746535062789917, 0.15392792224884033, -0.3650048077106476, -0.35543474555015564,
    0.16754835844039917, -0.28455936908721924, -0.12329373508691788, 0.28007572889328003, -0.0016645776340737939,
    -0.47041964530944824, -0.3467581868171692,
  ],
  [
    -0.19347184896469116, -0.041590429842472076, -0.2226325422525406, 0.42362266778945923, -0.11265675723552704,
    0.09035886079072952, 0.014066166244447231, 0.09585797041654587, -0.30589208006858826, 0.2180345207452774,
    0.1257685422897339, 0.4279778301715851,
  ],
  [
    -0.48083850741386414, 0.5641252398490906, -0.11428223550319672, 0.08715999126434326, 0.26019030809402466,
    0.19788680970668793, -0.08033347874879837, -0.27998968958854675, 0.18242581188678741, -0.07221312075853348,
    0.45371901988983154, -0.30841493606567383,
  ],
  [
    -0.20392948389053345, -0.23725196719169617, -0.13338638842105865, -0.10233914852142334, -0.42077159881591797,
    -0.4173595905303955, 0.34401655197143555, -0.16874007880687714, -0.15102602541446686, -0.42577406764030457,
    0.008873732760548592, -0.3387753963470459,
  ],
  [
    0.5743394494056702, 0.3191390335559845, 0.1749124377965927, 0.33891040086746216, -0.529649555683136,
    0.32811328768730164, 0.4173436462879181, 0.04628961160778999, -0.34631919860839844, 0.45532456040382385,
    -0.19196854531764984, -0.34580788016319275,
  ],
  [
    0.3319895267486572, 0.2209210842847824, -0.057477738708257675, 0.36609309911727905, 0.382527619600296,
    0.16217553615570068, 0.03413616120815277, -0.027965743094682693, 0.20804588496685028, -0.11431297659873962,
    0.12171906232833862, -0.24924929440021515,
  ],
  [
    -1.191690444946289, -0.14633579552173615, -0.09768460690975189, 0.03873160853981972, -0.4651733338832855,
    0.3333505392074585, 0.04626041650772095, -0.10177948325872421, -0.02748388983309269, -0.04164821282029152,
    0.3522983491420746, -0.013433866202831268,
  ],
  [
    0.1362277865409851, 0.2682274580001831, 0.1762397587299347, -0.05467599257826805, 0.35730162262916565,
    -0.14564527571201324, -0.9694510102272034, 0.061965130269527435, 0.16508767008781433, 0.1695702224969864,
    0.03141476586461067, 0.4686938524246216,
  ],
  [
    0.060489196330308914, 0.30032914876937866, -0.07339010387659073, -0.4134890139102936, -0.5013741254806519,
    -0.04245005175471306, 0.6953597664833069, 0.2532248795032501, 0.37125808000564575, 0.29514074325561523,
    0.21972785890102386, 0.23830048739910126,
  ],
  [
    -0.28094056248664856, 0.29670748114585876, -0.1192764863371849, 0.11054539680480957, -0.39111557602882385,
    -0.23175887763500214, -0.6975155472755432, -0.4338570833206177, -0.3483275771141052, -0.4007071256637573,
    -0.15867990255355835, -0.0698099285364151,
  ],
  [
    0.07013792544603348, 0.04325735941529274, 0.21044261753559113, -0.2418157160282135, -0.006103569641709328,
    0.14355356991291046, 0.5065286755561829, 0.38423845171928406, 0.14528819918632507, 0.8860445022583008,
    0.05523126572370529, -0.15480759739875793,
  ],
  [
    -0.31360435485839844, 0.3925805985927582, 0.16277460753917694, -0.1531638503074646, 0.182358056306839,
    -0.5892139077186584, -0.8260769248008728, 0.28082260489463806, 0.21130602061748505, 0.29885661602020264,
    0.09647569060325623, 0.10034911334514618,
  ],
  [
    0.12307596206665039, 0.08194314688444138, -0.011663263663649559, 0.02312471717596054, -0.6134036779403687,
    -0.5882237553596497, 0.07829762250185013, -0.1465979367494583, 0.019904565066099167, -0.278387188911438,
    -0.021916933357715607, 0.15578007698059082,
  ],
  [
    0.29513755440711975, -0.15710517764091492, -0.07941434532403946, -0.31255626678466797, 0.24172215163707733,
    -0.11075740307569504, 0.3955124616622925, -0.04086815193295479, 0.002430874155834317, 0.03583402559161186,
    0.5812603235244751, -0.002032241551205516,
  ],
  [
    -0.15217317640781403, -0.08572951704263687, -0.07219954580068588, -0.4880942106246948, -0.36678388714790344,
    -0.5503567457199097, -0.7947658896446228, -0.28916507959365845, -0.09433629363775253, -1.106642246246338,
    0.04106615483760834, -0.07589445263147354,
  ],
  [
    0.28996336460113525, 0.3371705412864685, 0.23258887231349945, 0.008782243356108665, -0.10762952268123627,
    -0.10488620400428772, 0.20133568346500397, 0.4343915581703186, 0.0946090966463089, -0.20451146364212036,
    -0.2156790792942047, 0.1914331465959549,
  ],
  [
    -0.13920092582702637, 0.29651665687561035, 0.15047360956668854, 0.5234178900718689, -0.10698307305574417,
    -0.28107133507728577, -0.10434530675411224, 0.5952277779579163, 0.1907598376274109, -0.20505057275295258,
    -0.3840201795101166, -0.30653032660484314,
  ],
  [
    -0.1279231309890747, 0.3011307418346405, 0.14608526229858398, 0.38638612627983093, -0.17693504691123962,
    0.3759542405605316, -0.10888080298900604, 0.4475521743297577, 0.13186874985694885, -0.180788055062294,
    -0.3955371379852295, -0.09625228494405746,
  ],
  [
    -0.1192731112241745, 0.3414725363254547, 0.025695832446217537, -0.31521162390708923, -0.1861494928598404,
    0.1641443520784378, -0.11629852652549744, 0.3485601842403412, -0.009151126258075237, -0.16041399538516998,
    -0.3954584002494812, 0.1712844967842102,
  ],
  [
    -0.12288122624158859, 0.38790613412857056, -0.1276821494102478, 0.5373018383979797, -0.46949073672294617,
    -0.38096535205841064, -0.11944335699081421, 0.4146575331687927, -0.22385773062705994, -0.16988711059093475,
    -0.354153573513031, 0.37938210368156433,
  ],
  [
    -0.09718194603919983, 0.07247848808765411, 0.591141939163208, 0.35202261805534363, -0.4659137427806854,
    0.28536295890808105, -0.09513551741838455, -0.032681599259376526, 0.13161565363407135, -0.11754511296749115,
    -0.327213317155838, 0.5622527003288269,
  ],
  [
    -0.07348497956991196, 0.3899255096912384, 0.040965739637613297, -0.4722227454185486, 0.43122878670692444,
    -0.49235495924949646, -0.06658826023340225, -0.17529506981372833, 0.4735229015350342, -0.08608361333608627,
    -0.21942709386348724, 0.18583841621875763,
  ],
  [
    -0.07570498436689377, 0.40234774351119995, -0.2519409954547882, -0.2861292362213135, -0.23955091834068298,
    0.047365885227918625, -0.08144558221101761, -0.013450291939079762, 0.4215761423110962, -0.08444312959909439,
    -0.2718197703361511, 0.21828795969486237,
  ],
  [
    0.11037709563970566, 0.11037709563970566, 0.11037709563970566, 0.11037709563970566, 0.11037709563970566,
    0.11037709563970566, 0.11037709563970566, 0.11037709563970566, 0.11037709563970566, 0.11037709563970566,
    0.11037709563970566, 0.11037709563970566,
  ],
  [
    0.09012442827224731, 0.09012442827224731, 0.09012442827224731, 0.09012442827224731, 0.09012442827224731,
    0.09012442827224731, 0.09012442827224731, 0.09012442827224731, 0.09012442827224731, 0.09012442827224731,
    0.09012442827224731, 0.09012442827224731,
  ],
  [
    0.04367790371179581, 0.04367790371179581, 0.04367790371179581, 0.04367790371179581, 0.04367790371179581,
    0.04367790371179581, 0.04367790371179581, 0.04367790371179581, 0.04367790371179581, 0.04367790371179581,
    0.04367790371179581, 0.04367790371179581,
  ],
  [
    -0.03543895110487938, -0.03543895110487938, -0.03543895110487938, -0.03543895110487938, -0.03543895110487938,
    -0.03543895110487938, -0.03543895110487938, -0.03543895110487938, -0.03543895110487938, -0.03543895110487938,
    -0.03543895110487938, -0.03543895110487938,
  ],
  [
    -0.010497833602130413, -0.010497833602130413, -0.010497833602130413, -0.010497833602130413, -0.010497833602130413,
    -0.010497833602130413, -0.010497833602130413, -0.010497833602130413, -0.010497833602130413, -0.010497833602130413,
    -0.010497833602130413, -0.010497833602130413,
  ],
  [
    0.007822301238775253, 0.007822301238775253, 0.007822301238775253, 0.007822301238775253, 0.007822301238775253,
    0.007822301238775253, 0.007822301238775253, 0.007822301238775253, 0.007822301238775253, 0.007822301238775253,
    0.007822301238775253, 0.007822301238775253,
  ],
  [
    0.021779414266347885, 0.021779414266347885, 0.021779414266347885, 0.021779414266347885, 0.021779414266347885,
    0.021779414266347885, 0.021779414266347885, 0.021779414266347885, 0.021779414266347885, 0.021779414266347885,
    0.021779414266347885, 0.021779414266347885,
  ],
];

export const XAP = [
  0.7651938796043396, -0.06584926694631577, -0.9144589304924011, 0.9297793507575989, 0.23113980889320374,
  -0.31730231642723083, -0.22628585994243622, -0.5572056174278259, -0.0014526054728776217, -1.8507708311080933,
  -0.10695409774780273, -0.12492087483406067, -0.22262439131736755, -0.726849377155304, 0.5771263837814331,
  0.5093193650245667, -0.14724041521549225, -0.28076714277267456, -0.29655879735946655, 0.3513766825199127,
  -0.05249723419547081, 0.8852091431617737, -0.0005142174195498228, -0.0003953207051381469, 0.0007203895365819335,
  -0.00040816047112457454, -3.127280797343701e-5, -0.0012123038759455085, 0.0001618627575226128,
  -0.00034424816840328276, -0.0009070627274923027, -0.00014652418030891567, 0.0009378648246638477, 1.0765503644943237,
  1.3133541345596313, 1.530716061592102, -0.49572473764419556, 0.3986058831214905, 0.30829110741615295,
  -10.294941902160645, 0.9644866585731506, -0.2340238392353058, 1.3834408521652222, -0.30038872361183167,
  -0.00796727929264307, 0.04002882167696953, 0.006038939114660025, 0.04829026013612747, -0.013084427453577518,
  -0.3890649378299713, -0.011038652621209621, 0.009589032270014286, -0.06452365219593048, 0.0507337860763073,
  -0.01213514618575573, -0.03718627989292145, 0.029127024114131927, 0.07592815160751343, -0.4663771986961365,
  0.04945513233542442, 0.0030928640626370907, -0.03891439735889435, -0.030306514352560043, 0.34520992636680603,
  0.006926648784428835, -0.052834950387477875, -0.024522045627236366, -0.1048090010881424, -0.06661199033260345,
  -0.03442361205816269, -0.011783493682742119, 0.6086400151252747, 0.08843696862459183, -0.04173791781067848,
  0.3510097563266754, -0.07283396273851395, 0.049313321709632874, -0.1293478161096573, 0.3072315454483032,
  -0.034581735730171204, 0.0683412179350853, -0.705143928527832, 0.20454274117946625, 0.3673781752586365,
  0.30117085576057434, -0.19221971929073334, 0.45973828434944153, -0.5891715884208679, 0.27653467655181885,
  0.13106873631477356, 0.656609296798706, -0.46627405285835266, 0.13784529268741608, 0.6235790252685547,
  -0.1936611384153366, -1.3576117753982544, 0.6576369404792786, -0.39817288517951965, 0.980792224407196,
  0.6521791815757751, 0.598711371421814, -0.1021735817193985, 0.8600811958312988, 0.32507583498954773,
  0.41746193170547485, -0.39254361391067505, 1.0645716190338135, 0.24910037219524384, 0.25047653913497925,
  0.3422226309776306, 0.4359634220600128, 0.9725465178489685, 0.140686497092247, 0.07294284552335739,
  -0.0627409890294075, -0.24335171282291412, 2.3346171379089355, 0.26695701479911804, -0.0951177328824997,
  0.3032744228839874, 0.31352412700653076, -0.4487360715866089, -0.05591234937310219, 0.023027976974844933,
  0.0431271456182003, 0.8549508452415466, 0.42505693435668945, 0.3453178107738495, 0.07427926361560822,
  0.5378432273864746, 0.33783385157585144, 0.44963422417640686, -0.29873746633529663, -0.027251368388533592,
  0.44013723731040955, -0.4438440203666687, -0.47583451867103577, 0.14430442452430725, 0.2467494010925293,
  -0.1822502613067627, -0.03422662615776062, -0.46736177802085876, 0.2178632616996765, 0.019909430295228958,
  0.0896313339471817, -0.2707498073577881, 0.08167371898889542, 0.1543244868516922, -0.1330367624759674,
  -0.09939520061016083, -2.0809829235076904, 0.05039507523179054, 0.16606943309307098, -0.11009613424539566,
  1.922285795211792, -0.07443900406360626, 1.4983736276626587, -0.2157791405916214, -0.18517720699310303,
  0.6188513040542603, -1.028539776802063, -1.9997808933258057, -0.3520919382572174, -0.24057424068450928,
  1.5983624458312988, 0.0857262909412384, 0.6839991211891174, -0.6592908501625061, -0.025665266439318657,
  0.2201596051454544, -0.457465261220932, -0.3592957854270935, 1.2280288934707642, -0.048084694892168045,
  -0.14340661466121674, 0.23014016449451447, 0.4415675401687622, -0.04290293902158737, 0.5248268842697144,
  -0.022187696769833565, 0.41806715726852417, 0.04240693151950836, 0.25804999470710754, 0.03749597817659378,
  0.05680657923221588, -0.43105584383010864, -0.14794348180294037, -0.3138275444507599, 0.8527050018310547,
  -0.046110641211271286, 0.7219681143760681, -0.4052952229976654, -1.340555191040039, -0.15894223749637604,
  -0.1310558170080185, -0.7741076350212097, -0.4427846670150757, -0.9198863506317139, -0.10258177667856216,
  0.4251607656478882, 0.3665608763694763, 0.13023726642131805, -0.41773080825805664, 0.04349479824304581,
  0.08843972533941269, 0.05639133229851723, -0.1586877852678299, -0.37339895963668823, 0.08873671293258667,
  0.24000407755374908, -0.0444805733859539, 0.16263385117053986, -0.13407376408576965, -0.10234087705612183,
  0.0437152199447155, 0.26897600293159485, -0.2519010007381439, 0.060113728046417236, -0.18863320350646973,
  0.1959236115217209, -0.01276432815939188, -0.4533305764198303, -0.5122466087341309, 0.0346209742128849,
  -0.7168509364128113, 0.4582211971282959, 0.45366036891937256, -0.4595147371292114, 0.5589362382888794,
  -0.5139575600624084, 0.5226197838783264, -0.22860080003738403, -0.352422297000885, -0.10384783148765564,
  0.37528952956199646, 0.5665034651756287, 0.4024698734283447, -0.452600359916687, -0.48190852999687195,
  -0.044466499239206314, -0.6313422322273254, 0.4363395869731903, 0.08169542253017426, 0.00896221399307251,
  -0.4550754725933075, -0.16051700711250305, -0.30172666907310486, -0.17342180013656616, 0.11198447644710541,
  -0.4620709717273712, 0.27832144498825073, 0.2652919292449951, -0.4978421926498413, 0.6030181646347046,
  -0.3488495945930481, -0.14611214399337769, 0.7327947616577148, 0.03746207058429718, -0.18159273266792297,
  -0.19366849958896637, -0.1382070779800415, 0.1701606810092926, 0.15983030200004578, -0.3910770118236542,
  -0.3098123073577881, 0.19775927066802979, -0.5077504515647888, 0.11078215390443802, -0.3506818413734436,
  0.1220877543091774, 0.06658001989126205, -0.052962325513362885, -1.5758455991744995, -0.03578269109129906,
  -0.4874882400035858, -0.4399326741695404, -0.45268797874450684, 0.09880691766738892, 0.8803989291191101,
  -0.5483556985855103, -0.06644493341445923, -0.3834366202354431, 0.03069583885371685, 0.1785474717617035,
  0.20472408831119537, -0.4845552444458008, 0.15034322440624237, -0.416157603263855, 0.3268570303916931,
  -0.15135514736175537, 0.012402336113154888, 0.34074869751930237, -0.06376809626817703, -0.007391801569610834,
  -0.04686551168560982, -0.4672985374927521, 0.7746190428733826, 2.0369973182678223, 0.5147728323936462,
  0.06476664543151855, -1.725313663482666, 0.0411968007683754, -0.5747738480567932, -0.546625018119812,
  -0.19386988878250122, -0.05466170608997345, 0.25356224179267883, 0.6975313425064087, 0.8473984599113464,
  -0.2127668559551239, -0.252602219581604, -0.21157978475093842, 0.9617213010787964, 0.18414609134197235,
  0.29134202003479004, 0.2878958284854889, 1.5402029752731323, 0.30075910687446594, 0.3656120300292969,
  -0.38073015213012695, 0.03112339973449707, 0.09368419647216797, -0.013000855222344398, -0.44819509983062744,
  0.18156088888645172, 0.2857798635959625, 0.10717557370662689, -0.05381567403674126, -0.5448144674301147,
  -0.43541139364242554, -0.13182523846626282, -0.0017431378364562988, 0.07129371166229248, -0.4825722575187683,
  -0.860580325126648, -0.16158512234687805, -0.5470574498176575, -0.003754941513761878, -0.9213250279426575,
  -0.7914032340049744, 0.46468207240104675, -0.1312631219625473, 0, 0, 0.22388407588005066, 0.047923456877470016,
  -0.25586360692977905, -0.07104391604661942, -0.05396922677755356, 0.3774225115776062, -0.12549838423728943,
  -0.2122846245765686, 0.0447305291891098, 0.09448643028736115, 0.12974949181079865, 0.1912030130624771,
  0.2133982926607132, 0.2266245037317276, 0.24746668338775635, 0.25601693987846375, 0.24242950975894928,
  0.24469804763793945, 0.17827783524990082, -0.14829394221305847, 0.4791179299354553, -0.1975753903388977,
  0.08270740509033203, -0.03740343451499939, 0.05487382411956787, 0.505829393863678, -0.1844455599784851,
  -0.2512282729148865, 0.4563547968864441, 0.06155502796173096, -0.09797731041908264, 0.14848095178604126,
  0.3285156488418579, -0.28920456767082214, 0.5182365775108337, -0.3065008819103241, 0.020881593227386475,
  -0.2764205038547516, 0.5104435086250305, 0.5043413043022156, 0.18976712226867676, 0.23593251407146454,
  0.22415532171726227, 0.17453670501708984, 0.2315952330827713, 0.24514251947402954, 0.2558925449848175,
  0.29539868235588074, 0.2948315739631653, 0.2807333171367645, 0.2790486812591553, 0.2058323621749878,
  0.022341368719935417, 0.013244296424090862, -0.007197726052254438, 0.007621873170137405, 0.03700033575296402,
  0.05467924848198891, 0.07878988236188889, 0.11314205825328827, 0.094158835709095, 0.4491526484489441,
  0.49243807792663574, -0.11334508657455444, -0.019409719854593277, 0.049975622445344925, 0.06462376564741135,
  -0.006791775114834309, -0.01187113206833601, 0.08122258633375168, 0.1283852756023407, -0.049873366951942444,
  0.011769086122512817, -0.10781016200780869, -0.28388577699661255, 0.2795366048812866, -0.1873854547739029,
  0.13526815176010132, 0.060357384383678436, -0.40483152866363525, 0.19612032175064087, 0.2899802625179291,
  -0.46327918767929077, -0.43462517857551575, 0.29800018668174744, -0.1596560925245285, 0.4249202013015747,
  0.33915722370147705, 0.3696109652519226, -0.45642778277397156, -0.32545897364616394, -0.18987612426280975,
  0.18539001047611237, -0.2662697732448578, -0.19054564833641052, 0.17403261363506317, -0.04618650674819946,
  0.042617131024599075, 0.31102102994918823, 0.16827534139156342, 0.037055835127830505, -0.0036940257996320724,
  -0.07386219501495361, -0.07535471767187119, -0.047138988971710205, 0.005649121478199959, 0.048596933484077454,
  -0.004253988619893789, -0.30465570092201233, -0.31350257992744446, -0.09665706753730774, -0.48389217257499695,
  0.34002286195755005, -0.007078338414430618, -0.05922805890440941, -0.3111286759376526, 0.438737154006958,
  -0.4752849340438843, 0.3710974156856537, 0.26325905323028564, 0.11901216953992844, 0.1066114604473114,
  0.13207681477069855, 0.13058017194271088, 0.10160757601261139, 0.05139872059226036, 0.12937109172344208,
  -0.01609540358185768, 0.042421773076057434, 0.00276746042072773, 0.005839245393872261, 0.002669321605935693,
  0.0075404760427773, 0.009633696638047695, 0.010064185597002506, 0.014509490691125393, 0.014252731576561928,
  0.009364836849272251, 0.009461685083806515, 0.003566266503185034,
];
export const XBP = [
  0.002329048002138734, 0.09756871312856674, -1.1101601123809814, 0.35105401277542114, 0.4051186144351959,
  -0.3512589931488037, 1.2774873971939087, 0.17371398210525513, -0.2075156718492508, -0.25677675008773804,
  -0.7862941026687622, -0.8106376528739929, 0.35642603039741516, -1.154404640197754, 0.4837867021560669,
  -1.1282305717468262, -0.45432907342910767, 0.5489238500595093, 1.043384313583374, 0.4221108853816986,
  0.7874440550804138, 0.7234727144241333, 0.07867880910634995, 0.03705371543765068, -0.19507133960723877,
  -0.03693293407559395, -0.17582686245441437, 0.26741981506347656, 0.06655191630125046, -0.10664983838796616,
  0.05663888156414032, -0.1688828468322754, 0.16563354432582855, -0.07677803188562393, 0.8007681369781494,
  0.48346003890037537, -0.3673197031021118, 0.08969466388225555, 0.292815238237381, -0.5473864674568176,
  -0.768088161945343, 0.5224586725234985, -0.10082240402698517, -0.2630150318145752, -0.004750831983983517,
  0.034334227442741394, 0.00809627678245306, -0.057816799730062485, -0.009537797421216965, -0.2830740511417389,
  -0.0021610348485410213, -0.004229011945426464, -0.03345320746302605, 0.01886448636651039, 0.004619183950126171,
  -0.00040188516140915453, -0.0037291469052433968, 0.002113115508109331, 0.0024623232893645763, 0.0016489771660417318,
  -0.48944008350372314, -0.003299999749287963, -0.0006284528644755483, 0.0035432130098342896, -0.010591015219688416,
  0.0014646067284047604, -0.002847945550456643, -0.43099239468574524, -0.020581504330039024, 0.5349777936935425,
  0.05967777594923973, 0.26794934272766113, 0.14032626152038574, 0.03608051687479019, 0.2599509060382843,
  0.052438460290431976, -0.05391596257686615, 0.8406704068183899, 0.004958544857800007, 0.9587063789367676,
  -0.520638644695282, 0.7739074230194092, -0.056688450276851654, -0.14615124464035034, -0.20173215866088867,
  -0.21799813210964203, -0.492725670337677, -0.09655286371707916, -0.4764212667942047, -0.4039154052734375,
  0.34872788190841675, -0.1866396963596344, -0.3733501732349396, -0.9803880453109741, 0.46632272005081177,
  -0.1520998328924179, 0.1502682864665985, 0.3616272211074829, 1.2296372652053833, -0.23275518417358398,
  -0.3118833601474762, 0.08391734212636948, -0.25172439217567444, 0.531983494758606, 0.43886205554008484,
  0.27783554792404175, -0.24575361609458923, 0.32811981439590454, -0.27530089020729065, 0.3459847867488861,
  2.0781004428863525, -0.2086716741323471, 1.075677514076233, 0.3653312027454376, -3.815711736679077,
  -0.8745995163917542, 0.3182045519351959, -1.119827151298523, 1.759292721748352, 1.5379701852798462,
  -0.3260267376899719, 0.09268498420715332, -0.3696187734603882, 0.01197086088359356, -0.156763955950737,
  0.09613019973039627, -0.1955796331167221, -0.06590444594621658, -0.4253542125225067, 0.1744018942117691,
  -0.4500837028026581, 0.2436564713716507, 0.1990136057138443, -0.05797811225056648, 0.3894450068473816,
  1.1681408882141113, -0.5530254244804382, -0.462375283241272, 0.9386448860168457, 0.3493500351905823,
  0.14558136463165283, 0.18371550738811493, 0.39187031984329224, 0.45244160294532776, 0.5110905766487122,
  -0.13185253739356995, 0.033570289611816406, -0.02709674835205078, -0.26082661747932434, -0.34453681111335754,
  0.4019181728363037, -0.11436905711889267, 0.5117189884185791, -0.4984424114227295, -0.6461684107780457,
  -0.5047551393508911, -0.14920920133590698, 0.15985845029354095, 0.44846975803375244, 0.3845057785511017,
  -0.8335038423538208, -0.5741980075836182, -0.5320454239845276, 0.5221912264823914, 0.5392582416534424,
  -0.555386483669281, 0.3017939627170563, 0.863885760307312, -0.07117664068937302, -0.3800879716873169,
  -0.28644099831581116, -1.1557081937789917, -0.31448009610176086, -0.3412361145019531, 0.7669588923454285,
  0.6983420252799988, -0.2666632831096649, -0.5133678317070007, 0.2303464114665985, -0.18094104528427124,
  0.4801880419254303, 0.9128574132919312, 0.589169442653656, 0.6023663878440857, 0.19921794533729553,
  0.47135403752326965, -0.3198067247867584, 0.26329678297042847, 0.10923850536346436, 0.0902659147977829,
  -0.17786329984664917, 0.0583876371383667, -0.26976537704467773, 0.536831796169281, 0.2360827624797821,
  0.1733219027519226, 0.09696580469608307, -0.06817644089460373, -0.0660867989063263, -0.4243549704551697,
  -0.3461838364601135, -0.8288754224777222, -0.048116330057382584, -0.4453749358654022, -0.34818780422210693,
  -0.22509078681468964, -0.09835626184940338, -0.2898009717464447, -0.2480904459953308, 0.8264536261558533,
  -0.05789841711521149, -0.4115351736545563, 0.5172004699707031, 0.1225791871547699, -0.10816091299057007,
  0.2207125723361969, 0.6704581379890442, 0.5508435964584351, -0.011994999833405018, -0.08383388817310333,
  -0.282450795173645, 0.03182986006140709, -0.3123696446418762, -0.6366487741470337, -0.4539388418197632,
  0.8038759231567383, -0.512647807598114, -0.3161618411540985, 0.3361578583717346, 0.11566954851150513,
  0.47852012515068054, -0.07165789604187012, -0.19415640830993652, -0.048109155148267746, 0.2392943650484085,
  -0.40093252062797546, 0.28807321190834045, 0.3757302463054657, 0.43176546692848206, 0.12663011252880096,
  0.43170708417892456, 0.19949330389499664, -0.386300265789032, -0.16485460102558136, 0.26156947016716003,
  1.2365188598632812, 0.23973554372787476, 0.17007148265838623, -0.37964490056037903, -0.08085239678621292,
  -0.36534130573272705, -0.34718814492225647, 0.14976610243320465, 0.03601834923028946, 0.055157676339149475,
  -0.18886803090572357, -0.6663930416107178, 0.3972455859184265, 0.27241307497024536, 0.0738455057144165,
  -0.266578733921051, 0.13812127709388733, -0.14648306369781494, 0.31494301557540894, -0.05667543783783913,
  -0.6649905443191528, 0.4651619791984558, 0.00579726742580533, 0.13237765431404114, 0.052741922438144684,
  0.0009980601025745273, -0.01805628277361393, 0.006533226929605007, -0.5183758735656738, 0.8216782212257385,
  0.10444227606058121, 0.6840431690216064, -0.9592472910881042, -0.06653270125389099, -0.8309202194213867,
  -0.18208786845207214, -0.4118945300579071, 0.16206300258636475, -0.09573644399642944, 0.11762374639511108,
  -0.41265997290611267, -0.430105596780777, 0.9897926449775696, -0.04080349579453468, -0.11984480917453766,
  0.5900567173957825, 0.380343496799469, 0.04665074869990349, 0.2181934118270874, 0.17600621283054352,
  -0.30425548553466797, -0.3654893636703491, -0.3555756211280823, 0.4407721757888794, 0.055762819945812225,
  0.899366557598114, 0.5207844972610474, -0.19259484112262726, 0.23980922996997833, -0.37316393852233887,
  0.17379523813724518, 0.40693914890289307, 0.662441611289978, -0.22918130457401276, 0.1563953161239624,
  0.5004065632820129, 0.8314793109893799, 0.7489714026451111, 0.2660185992717743, -0.41474583745002747,
  -0.3013423681259155, -0.25042492151260376, -0.3018535375595093, 0.47661104798316956, -0.4720555245876312,
  -0.2059127688407898, 0.3163042664527893, 0.024284228682518005, -0.5889205932617188, -0.1453820765018463,
  0.1079707220196724, 0.02057885378599167, 0.6950498819351196, -0.17936629056930542, -0.2507874369621277,
  0.3126922845840454, 0.24616862833499908, -1.4433268308639526, 0.5610532164573669, -0.56910640001297,
  -0.6080460548400879, 0.01774817705154419, -0.21665523946285248, -0.3872665464878082, -0.08692046999931335,
  -0.3022732138633728, -0.057670097798109055, 0.0010382496984675527, 0.376421719789505, -1.1278188228607178,
  -0.2320125252008438, 0.4924449026584625, -0.20258446037769318, -0.006284657400101423, 0.12138640135526657, 0,
  0.15450678765773773, -0.12209416180849075, -0.3731536865234375, -0.3580571115016937, 0.26146650314331055,
  -0.3735732138156891, 0.28078946471214294, 0.43775492906570435, 0.08659370243549347, -0.3035396933555603,
  -0.4914878308773041, 0.40807101130485535, 0.24133989214897156, 0.2150503396987915, 0.16406695544719696,
  0.06458226591348648, 0.020091677084565163, -0.005265770945698023, -0.019979527220129967, -0.05141536146402359,
  -0.049851011484861374, -0.13927291333675385, -0.12683546543121338, 0.025826983153820038, 0.017259467393159866,
  -0.004478122107684612, -0.06719481199979782, -0.08987283706665039, -0.09252555668354034, -0.078013114631176,
  -0.05551816150546074, -0.07344048470258713, 0.26138898730278015, 0.382840633392334, -0.17663294076919556,
  -0.21825994551181793, -0.25904661417007446, -0.3027406334877014, -0.33122506737709045, -0.34823673963546753,
  -0.353484570980072, -0.36707913875579834, -0.3727303147315979, -0.35735124349594116, -0.29207873344421387,
  0.2990143597126007, 0.2686888873577118, 0.22379344701766968, 0.17284832894802094, 0.16063958406448364,
  0.13695572316646576, 0.10121594369411469, 0.06341732293367386, 0.09130251407623291, -0.004088096786290407,
  0.0575278103351593, 0.16625092923641205, 0.16565118730068207, 0.1806270331144333, 0.26202255487442017,
  0.31261852383613586, 0.32975703477859497, 0.31872454285621643, 0.3283954858779907, 0.3530579209327698,
  0.3211921751499176, 0.27057620882987976, 0.30419212579727173, -0.4014492630958557, 0.20720142126083374,
  0.3913877606391907, -0.39419007301330566, 0.3153228759765625, -0.09596578776836395, -0.32776930928230286,
  -0.15717332065105438, -0.2431987226009369, 0.26223424077033997, 0.10157858580350876, 0.07205305993556976,
  0.04569334164261818, 0.21020327508449554, -0.01892942562699318, -0.163858562707901, 0.1626177877187729,
  -0.2942805886268616, -0.2241177260875702, -0.2648172676563263, 0.4595503807067871, -0.3471619188785553,
  -0.2234860509634018, -0.10878870636224747, -0.04862355813384056, -0.06394091248512268, -0.0476338267326355,
  0.007170445751398802, 0.04826515540480614, -0.00679742731153965, 0.04167431220412254, 0.00786628294736147,
  0.36034560203552246, 0.4164963960647583, 0.11178547143936157, 0.502325713634491, -0.5041953325271606,
  -0.1823703646659851, 0.25916367769241333, 0.4915134310722351, 0.4935808777809143, -0.4567396640777588,
  -0.4725889265537262, 0.1506006270647049, 0.1884574145078659, 0.21065568923950195, 0.21861447393894196,
  0.2120031863451004, 0.20845763385295868, 0.21073143184185028, 0.20549187064170837, 0.20114055275917053,
  0.12632964551448822, 0.09156917780637741, 0.1297227442264557, 0.08516684919595718, 0.043026089668273926,
  0.019542215391993523, 0.024668263271450996, 0.019034892320632935, -0.00011556452955119312, -0.0147019661962986,
  0.004596944432705641, -0.011404326185584068, -0.0010633058845996857,
];
export const XCP = [
  -0.2616492509841919, 0.0007581497193314135, 0.3212491571903229, 0.00036529696080833673, 0.07325676828622818,
  -0.001998174237087369, -0.0045743584632873535, 0.0033677767496556044, -0.014279593713581562, -0.13585996627807617,
  0.012572364881634712, -0.49512872099876404, 0.009137643501162529, -0.6038380861282349, -0.020204676315188408,
  -0.15879149734973907, 0.01525481604039669, 0.06880632787942886, 0.011440406553447247, 0.3016999661922455,
  -0.4161315858364105, -0.25885751843452454, -0.11076129972934723, 0.00012388524191919714, -0.2724604606628418,
  0.0015540648018941283, -0.0064986455254256725, -0.0009270554292015731, -0.0018701431108638644, 0.0014548483304679394,
  -0.00631335936486721, 0.3500596582889557, 0.004037919919937849, -0.5050521492958069, -1.4188017845153809,
  -0.384713351726532, -1.3401362895965576, 0.10385429859161377, -1.3205755949020386, 1.3505066633224487,
  0.028908515349030495, 2.7588417530059814, 0.25188860297203064, 2.0148115158081055, 0.020381219685077667,
  -0.0006041703163646162, -0.5249200463294983, 0.0002626347413752228, 0.2941434383392334, 0.0006172404391691089,
  -0.002102414844557643, 8.921649714466184e-5, -0.013053050264716148, 0.1739206165075302, 0.010949281975626945,
  -0.1367243528366089, 0.0013863279018551111, 0.18154773116111755, -0.0013843384804204106, -0.23111875355243683,
  0.0016728694317862391, -0.0060736373998224735, 0.008739262819290161, -0.010088281705975533, -0.4447158873081207,
  0.010596983134746552, 0.47810766100883484, 0.331726998090744, 0.04867301881313324, 0.3492199778556824,
  -0.030631965026259422, -0.27101564407348633, -0.6500954031944275, -0.9057721495628357, 0.27526211738586426,
  -0.2026379555463791, 0.08539459854364395, -0.0076391128823161125, 0.368767112493515, -0.11239130049943924,
  0.6488680243492126, -0.12717922031879425, 0.8384792804718018, 0.502612829208374, 0.41143855452537537,
  -0.027953408658504486, -0.08805573731660843, 0.3594420552253723, 0.43235960602760315, -0.4061759114265442,
  0.03795627877116203, -0.07386303693056107, -0.2822858393192291, -0.5306805372238159, -0.2261507511138916,
  0.3243566155433655, 0.14291925728321075, 0.0337950773537159, 0.02069893851876259, 0.13093122839927673,
  0.30437207221984863, 0.0980738177895546, -0.18137286603450775, -0.18608079850673676, 0.07041072845458984,
  0.17723047733306885, -0.49232909083366394, -0.4805908501148224, -0.13008221983909607, -0.3299570679664612,
  -0.02321096695959568, 0.05680828168988228, 0.1942746341228485, -0.019890792667865753, -0.42300257086753845,
  -0.20256732404232025, 0.09539522230625153, -0.4152785539627075, -0.3733808994293213, -0.287136048078537,
  0.0487249530851841, 0.5382143259048462, -0.22441458702087402, -1.1164109706878662, -0.4157102108001709,
  0.21849951148033142, -0.4256565570831299, 0.8073329329490662, -0.23801666498184204, -0.5205596089363098,
  0.45027539134025574, 0.06289145350456238, -0.15124548971652985, 0.5371046662330627, -0.15721482038497925,
  0.0035403224173933268, -0.29576748609542847, -0.06249985471367836, -0.06643635779619217, 0.47639763355255127,
  0.3810678720474243, 0.12228067964315414, -0.21206112205982208, 0.8140373826026917, -0.1754479706287384,
  0.10201887786388397, -0.0726521909236908, -0.8923516273498535, -0.2308388352394104, 0.4986942708492279,
  0.06249506026506424, 0.25304171442985535, -0.06325847655534744, -0.762410581111908, -0.10758703947067261,
  -0.17269816994667053, 0.7631587982177734, 0.2107691764831543, 0.3110600411891937, 0.5882901549339294,
  -0.5312445163726807, 0.03513794019818306, 0.23575080931186676, 0.16249027848243713, 0.3306020498275757,
  -0.03354540467262268, -0.16411523520946503, 0.6839039921760559, -0.021541306748986244, -0.09799625724554062,
  0.23686231672763824, 0.34588128328323364, -0.3706425726413727, 0.4561014473438263, -0.048404816538095474,
  0.01423341128975153, -0.603976309299469, -0.11640781164169312, 0.18477386236190796, 0.3150867521762848,
  0.4682559370994568, -0.4506426751613617, -0.8874660730361938, -0.020965198054909706, 0.03104545921087265,
  0.3865678310394287, 0.8192485570907593, 0.44856131076812744, 0.11833249032497406, -0.1377313733100891,
  -0.45869386196136475, -0.024493135511875153, 0.14226365089416504, 0.11601746082305908, -0.09114044904708862,
  0.2586655616760254, 0.18659979104995728, -0.3875931203365326, -0.7217836976051331, -0.3783486485481262,
  0.6300257444381714, 0.6133254766464233, 0.5437189340591431, -0.2441302239894867, -1.2245131731033325,
  -0.01437678188085556, 0.04808527231216431, 0.4145638346672058, 0.9597285985946655, 0.23025667667388916,
  0.03902922198176384, -0.47529467940330505, 0.3198230564594269, 0.7401978373527527, 0.8133041858673096,
  0.07317731529474258, -0.05422060936689377, 0.6082064509391785, -1.086893081665039, 0.43878015875816345,
  -0.10297618806362152, -0.5317414999008179, -0.0124996118247509, 0.09236899018287659, -0.1183973178267479,
  -0.07071256637573242, -0.49083325266838074, -0.23154819011688232, 0.8654428720474243, -0.5406859517097473,
  -0.04754333570599556, 0.0357571616768837, 0.18823979794979095, 0.23045557737350464, 0.21713589131832123,
  -0.3717089593410492, 0.02901369333267212, 0.14929386973381042, 0.0938652753829956, 0.23757405579090118,
  -0.10691364854574203, 0.28875821828842163, 0.37235912680625916, 0.06692390143871307, -0.23672284185886383,
  -0.5039178729057312, -0.7630974650382996, -0.10751017928123474, 0.37964922189712524, 0.16980665922164917,
  -0.3426566421985626, -0.11550726741552353, -0.08880705386400223, 0.3512927293777466, 0.3259442150592804,
  0.3656154274940491, 0.36350494623184204, 0.3746466338634491, -0.2662945091724396, 0.42699652910232544,
  -0.2878771722316742, -0.7280986905097961, 0.0407983623445034, -0.5324389338493347, -0.04424978420138359,
  0.5241444706916809, -0.27266421914100647, -0.4272763133049011, 0.4330061674118042, -0.16352859139442444,
  -0.48296916484832764, -0.4280916750431061, -1.2962359189987183, 0.45013219118118286, -0.05320748686790466,
  -0.5282207131385803, -0.22961343824863434, -0.3825279772281647, 0.17545025050640106, 0.4428335428237915,
  0.3115426003932953, 0.0498114675283432, -0.4755150377750397, -0.5545654296875, 0.04732887074351311,
  1.1056619882583618, -0.004916252102702856, -0.5608271956443787, -0.5116857886314392, 0.15564648807048798,
  -0.1738833636045456, -0.2560816705226898, 0.011631363071501255, 0.05567467212677002, 0.8213002681732178,
  -0.5003489851951599, 0.5812626481056213, 0.2470412403345108, -0.47916558384895325, 0.09367246925830841,
  0.45449191331863403, 0.40212002396583557, 0.42533111572265625, -0.01132303848862648, -0.5209296345710754,
  0.09018565714359283, 0.2819892168045044, 0.41585859656333923, -0.41378557682037354, 0.4553666412830353,
  0.022145951166749, 0.16621099412441254, 0.559873640537262, -0.531044602394104, -0.03602074831724167,
  0.13367494940757751, -0.18373346328735352, 0.22187691926956177, 0.1679569035768509, 0.07417038828134537,
  -0.9283341765403748, -0.32778796553611755, 0.160516619682312, -0.5150997638702393, -0.0043329596519470215,
  -0.38297784328460693, -0.3129558563232422, 0.2405557632446289, -1.170612096786499, 0.2871442139148712,
  -0.3103693127632141, 0.5647217631340027, 0.0701540857553482, 0.33050474524497986, -0.18983151018619537,
  0.09103208780288696, -0.42435839772224426, 0.04168165475130081, -2.0690786838531494, 0.6186273694038391,
  0.3282012641429901, -0.11746826022863388, 0.3215690553188324, -0.08709472417831421, -0.19158481061458588,
  0.10095714777708054, -0.028732851147651672, -0.07290303707122803, -0.01010989397764206, -0.3418891131877899,
  0.5639673471450806, -0.5729118585586548, -0.031688619405031204, -0.42689248919487, 0.04796867445111275,
  -0.18517780303955078, -0.13190032541751862, 0.4694533050060272, 0.22737808525562286, -0.10007541626691818,
  0.25026610493659973, -0.4361329674720764, 0.4765334725379944, 0.7578757405281067, 0.6472752094268799,
  0.4557726979255676, 0.31299349665641785, 0.28306636214256287, 0.26298579573631287, 0.24684898555278778,
  0.2315661758184433, 0.23805221915245056, 0.21802513301372528, 0.1971801519393921, -0.1865473985671997,
  0.3849121332168579, 0.3119029104709625, 0.10619137436151505, -0.2347092479467392, -0.16024228930473328,
  -0.40119922161102295, 0.1124715730547905, -0.05281306803226471, -0.29389798641204834, 0.4716587960720062,
  -0.30411282181739807, -0.2376604676246643, -0.14288879930973053, -0.08150001615285873, -0.06971549242734909,
  -0.06271336227655411, -0.05364728718996048, -0.03638766333460808, -0.04406704008579254, 0.06746499240398407,
  0.09390690177679062, 0.5250244736671448, 0.4329816699028015, 0.2854168117046356, 0.16835759580135345,
  0.14129512012004852, 0.12501496076583862, 0.10903092473745346, 0.08695710450410843, 0.09655145555734634,
  -0.010916965082287788, -0.019746622070670128, 0.24948373436927795, -0.3124904930591583, -0.062393393367528915,
  -0.5202824473381042, -0.23909924924373627, -0.04422873631119728, 0.06850646436214447, -0.43306511640548706,
  0.3967125415802002, -0.07774393260478973, 0.1513347178697586, -0.3695286512374878, -0.38101616501808167,
  -0.26241379976272583, 0.007210454437881708, 0.5024915933609009, 0.05298745259642601, -0.04546349123120308,
  -0.00017279869643971324, 0.4769110679626465, 0.2644558548927307, 0.0893084704875946, -0.4474693536758423,
  0.11181757599115372, -0.24909153580665588, 0.0709788128733635, -0.16229447722434998, -0.39337560534477234,
  0.12411802262067795, -0.5074143409729004, -0.16867473721504211, -0.08085102587938309, -0.32917627692222595,
  1.0010807514190674, 0.7359352111816406, 0.40678825974464417, 0.18125371634960175, 0.1346113681793213,
  0.10763086378574371, 0.0813777819275856, 0.04853171855211258, 0.06164092570543289, -0.03831222280859947,
  -0.007907169871032238, -0.8522756099700928, -0.6565479636192322, -0.38534265756607056, -0.18368667364120483,
  -0.1417212039232254, -0.11366292834281921, -0.09081893414258957, -0.0685386136174202, -0.07802969217300415,
  -0.052791777998209, -0.023647770285606384, 0.1772952526807785, 0.15185369551181793, 0.10269501805305481,
  0.06150202453136444, 0.05200837925076485, 0.046531740576028824, 0.0384766086935997, 0.023722562938928604,
  0.029755566269159317, 0.0239387359470129, -0.008255086839199066, 0.1526813805103302, 0.11332876980304718,
  0.061603087931871414, 0.022375965490937233, 0.014218008145689964, 0.008716832846403122, 0.004440539516508579,
  0.000819179811514914, 0.0023656932171434164, 0.00869049783796072, 0.009168000891804695,
];
